// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders, PartialBy } from '../types';

export const AuthHttpGetApps = 'AuthHttpGetApps' as const;
export const AuthHttpPostApps = 'AuthHttpPostApps' as const;
export const AuthHttpPostAppsExternalAuth =
  'AuthHttpPostAppsExternalAuth' as const;
export const AuthHttpGetAppsExternalAuthBySecret =
  'AuthHttpGetAppsExternalAuthBySecret' as const;
export const AuthHttpPostAppsInstance = 'AuthHttpPostAppsInstance' as const;
export const AuthHttpDeleteAppsInstanceByApprovedInstanceId =
  'AuthHttpDeleteAppsInstanceByApprovedInstanceId' as const;
export const AuthHttpGetAppsInstanceByApprovedInstanceId =
  'AuthHttpGetAppsInstanceByApprovedInstanceId' as const;
export const AuthHttpGetAppsOauthScopes = 'AuthHttpGetAppsOauthScopes' as const;
export const AuthHttpDeleteAppsByAppId = 'AuthHttpDeleteAppsByAppId' as const;
export const AuthHttpGetAppsByAppId = 'AuthHttpGetAppsByAppId' as const;
export const AuthHttpPatchAppsByAppId = 'AuthHttpPatchAppsByAppId' as const;
export const AuthHttpPutAppsByAppId = 'AuthHttpPutAppsByAppId' as const;
export const AuthHttpPostAppsByAppIdToken =
  'AuthHttpPostAppsByAppIdToken' as const;
export const AuthHttpPostAuthAdLogin = 'AuthHttpPostAuthAdLogin' as const;
export const AuthHttpPostAuthCurrentOtpGenerate =
  'AuthHttpPostAuthCurrentOtpGenerate' as const;
export const AuthHttpPostAuthEmbedToken = 'AuthHttpPostAuthEmbedToken' as const;
export const AuthHttpPostAuthEmbedTokenExchange =
  'AuthHttpPostAuthEmbedTokenExchange' as const;
export const AuthHttpPostAuthMultidomainLogin =
  'AuthHttpPostAuthMultidomainLogin' as const;
export const AuthHttpPostAuthOtpGenerate =
  'AuthHttpPostAuthOtpGenerate' as const;
export const AuthHttpPostAuthSamlAcsByPublicId =
  'AuthHttpPostAuthSamlAcsByPublicId' as const;
export const AuthHttpPostAuthSamlAcsBySystemDomainIdByIdentityProviderId =
  'AuthHttpPostAuthSamlAcsBySystemDomainIdByIdentityProviderId' as const;
export const AuthHttpPostAuthSamlDomains =
  'AuthHttpPostAuthSamlDomains' as const;
export const AuthHttpDeleteAuthSamlDomainsByDomain =
  'AuthHttpDeleteAuthSamlDomainsByDomain' as const;
export const AuthHttpGetAuthSamlIdp = 'AuthHttpGetAuthSamlIdp' as const;
export const AuthHttpPostAuthSamlIdp = 'AuthHttpPostAuthSamlIdp' as const;
export const AuthHttpPostAuthSamlIdpConvert =
  'AuthHttpPostAuthSamlIdpConvert' as const;
export const AuthHttpDeleteAuthSamlIdpByIdentityProviderId =
  'AuthHttpDeleteAuthSamlIdpByIdentityProviderId' as const;
export const AuthHttpGetAuthSamlIdpByIdentityProviderId =
  'AuthHttpGetAuthSamlIdpByIdentityProviderId' as const;
export const AuthHttpPatchAuthSamlIdpByIdentityProviderId =
  'AuthHttpPatchAuthSamlIdpByIdentityProviderId' as const;
export const AuthHttpPutAuthSamlIdpByIdentityProviderId =
  'AuthHttpPutAuthSamlIdpByIdentityProviderId' as const;
export const AuthHttpPostAuthSamlLogin = 'AuthHttpPostAuthSamlLogin' as const;
export const AuthHttpPostAuthSamlLogoutByPublicId =
  'AuthHttpPostAuthSamlLogoutByPublicId' as const;
export const AuthHttpGetAuthSamlMetadataByPublicId =
  'AuthHttpGetAuthSamlMetadataByPublicId' as const;
export const AuthHttpGetAuthSamlMetadataBySystemDomainIdByIdentityProviderId =
  'AuthHttpGetAuthSamlMetadataBySystemDomainIdByIdentityProviderId' as const;
export const AuthHttpPostAuthSamlMultidomainLogin =
  'AuthHttpPostAuthSamlMultidomainLogin' as const;
export const AuthHttpGetAuthSamlSloByPublicId =
  'AuthHttpGetAuthSamlSloByPublicId' as const;
export const AuthHttpGetAuthSamlSloBySystemDomainIdByIdentityProviderId =
  'AuthHttpGetAuthSamlSloBySystemDomainIdByIdentityProviderId' as const;
export const AuthHttpGetAuthSamlSsoByPublicId =
  'AuthHttpGetAuthSamlSsoByPublicId' as const;
export const AuthHttpGetAuthSamlSsoBySystemDomainIdByIdentityProviderId =
  'AuthHttpGetAuthSamlSsoBySystemDomainIdByIdentityProviderId' as const;
export const AuthHttpPostAuthSimpleLogin =
  'AuthHttpPostAuthSimpleLogin' as const;
export const AuthHttpDeleteAuthToken = 'AuthHttpDeleteAuthToken' as const;
export const AuthHttpGetAuthToken = 'AuthHttpGetAuthToken' as const;
export const AuthHttpPostAuthToken = 'AuthHttpPostAuthToken' as const;
export const AuthHttpPutAuthToken = 'AuthHttpPutAuthToken' as const;
export const AuthHttpDeleteAuthTokenByTokenId =
  'AuthHttpDeleteAuthTokenByTokenId' as const;
export const AuthHttpGetAuthTokenByTokenId =
  'AuthHttpGetAuthTokenByTokenId' as const;
export const AuthHttpGetAuthTokens = 'AuthHttpGetAuthTokens' as const;
export const AuthHttpGetAuthByAppIdTokens =
  'AuthHttpGetAuthByAppIdTokens' as const;
export const AuthHttpPutInvitationCompleteByResetHash =
  'AuthHttpPutInvitationCompleteByResetHash' as const;
export const AuthHttpPostMarketplaceGoogleLink =
  'AuthHttpPostMarketplaceGoogleLink' as const;
export const AuthHttpPostMarketplaceGoogleSignup =
  'AuthHttpPostMarketplaceGoogleSignup' as const;
export const AuthHttpGetOauthAuthorize = 'AuthHttpGetOauthAuthorize' as const;
export const AuthHttpPostOauthAuthorize = 'AuthHttpPostOauthAuthorize' as const;
export const AuthHttpPostOauthToken = 'AuthHttpPostOauthToken' as const;
export const AuthHttpGetPasswordChecks = 'AuthHttpGetPasswordChecks' as const;
export const AuthHttpPostPasswordForgot = 'AuthHttpPostPasswordForgot' as const;
export const AuthHttpPutPasswordResetByResetHash =
  'AuthHttpPutPasswordResetByResetHash' as const;
export const AuthHttpGetPasswordByResetHashChecks =
  'AuthHttpGetPasswordByResetHashChecks' as const;
export const AuthHttpGetReferralCodes = 'AuthHttpGetReferralCodes' as const;
export const AuthHttpPostReferralCodes = 'AuthHttpPostReferralCodes' as const;
export const AuthHttpDeleteReferralCodesByCode =
  'AuthHttpDeleteReferralCodesByCode' as const;
export const AuthHttpGetReferralCodesByCode =
  'AuthHttpGetReferralCodesByCode' as const;
export const AuthHttpPostRegistrations = 'AuthHttpPostRegistrations' as const;
export const AuthHttpGetRegistrationsContent =
  'AuthHttpGetRegistrationsContent' as const;
export const AuthHttpGetRegistrationsCountries =
  'AuthHttpGetRegistrationsCountries' as const;
export const AuthHttpPostRegistrationsVerifyByEmailHash =
  'AuthHttpPostRegistrationsVerifyByEmailHash' as const;
export const AuthHttpGetScimConfig = 'AuthHttpGetScimConfig' as const;
export const AuthHttpPostScimConfig = 'AuthHttpPostScimConfig' as const;
export const AuthHttpDeleteScimConfigByConfigId =
  'AuthHttpDeleteScimConfigByConfigId' as const;
export const AuthHttpGetScimConfigByConfigId =
  'AuthHttpGetScimConfigByConfigId' as const;
export const AuthHttpPatchScimConfigByConfigId =
  'AuthHttpPatchScimConfigByConfigId' as const;
export const AuthHttpPutScimConfigByConfigId =
  'AuthHttpPutScimConfigByConfigId' as const;
export const AuthHttpGetScimConfigByConfigIdGroups =
  'AuthHttpGetScimConfigByConfigIdGroups' as const;
export const AuthHttpPutScimConfigByConfigIdGroups =
  'AuthHttpPutScimConfigByConfigIdGroups' as const;
export const AuthHttpDeleteScimConfigByConfigIdGroupsByGroupId =
  'AuthHttpDeleteScimConfigByConfigIdGroupsByGroupId' as const;
export const AuthHttpDeleteScimConfigByConfigIdToken =
  'AuthHttpDeleteScimConfigByConfigIdToken' as const;
export const AuthHttpPostScimConfigByConfigIdToken =
  'AuthHttpPostScimConfigByConfigIdToken' as const;
export const AuthHttpGetScimV2Groups = 'AuthHttpGetScimV2Groups' as const;
export const AuthHttpPostScimV2Groups = 'AuthHttpPostScimV2Groups' as const;
export const AuthHttpDeleteScimV2GroupsByGroupId =
  'AuthHttpDeleteScimV2GroupsByGroupId' as const;
export const AuthHttpGetScimV2GroupsByGroupId =
  'AuthHttpGetScimV2GroupsByGroupId' as const;
export const AuthHttpPatchScimV2GroupsByGroupId =
  'AuthHttpPatchScimV2GroupsByGroupId' as const;
export const AuthHttpPutScimV2GroupsByGroupId =
  'AuthHttpPutScimV2GroupsByGroupId' as const;
export const AuthHttpGetScimV2ResourceTypes =
  'AuthHttpGetScimV2ResourceTypes' as const;
export const AuthHttpGetScimV2ResourceTypesByResource =
  'AuthHttpGetScimV2ResourceTypesByResource' as const;
export const AuthHttpGetScimV2Schemas = 'AuthHttpGetScimV2Schemas' as const;
export const AuthHttpGetScimV2SchemasBySchemaId =
  'AuthHttpGetScimV2SchemasBySchemaId' as const;
export const AuthHttpGetScimV2ServiceProviderConfig =
  'AuthHttpGetScimV2ServiceProviderConfig' as const;
export const AuthHttpGetScimV2Users = 'AuthHttpGetScimV2Users' as const;
export const AuthHttpPostScimV2Users = 'AuthHttpPostScimV2Users' as const;
export const AuthHttpDeleteScimV2UsersByUserId =
  'AuthHttpDeleteScimV2UsersByUserId' as const;
export const AuthHttpGetScimV2UsersByUserId =
  'AuthHttpGetScimV2UsersByUserId' as const;
export const AuthHttpPatchScimV2UsersByUserId =
  'AuthHttpPatchScimV2UsersByUserId' as const;
export const AuthHttpPutScimV2UsersByUserId =
  'AuthHttpPutScimV2UsersByUserId' as const;
export const AuthHttpGetSystemDomains = 'AuthHttpGetSystemDomains' as const;
export const AuthHttpPostSystemDomains = 'AuthHttpPostSystemDomains' as const;
export const AuthHttpGetSystemDomainsBasicBySystemDomainId =
  'AuthHttpGetSystemDomainsBasicBySystemDomainId' as const;
export const AuthHttpPostSystemDomainsFromTemplateByTemplateId =
  'AuthHttpPostSystemDomainsFromTemplateByTemplateId' as const;
export const AuthHttpPostSystemDomainsReferralCodeByReferralCode =
  'AuthHttpPostSystemDomainsReferralCodeByReferralCode' as const;
export const AuthHttpGetSystemDomainsSearch =
  'AuthHttpGetSystemDomainsSearch' as const;
export const AuthHttpGetSystemDomainsTemplates =
  'AuthHttpGetSystemDomainsTemplates' as const;
export const AuthHttpDeleteSystemDomainsBySystemDomainId =
  'AuthHttpDeleteSystemDomainsBySystemDomainId' as const;
export const AuthHttpGetSystemDomainsBySystemDomainId =
  'AuthHttpGetSystemDomainsBySystemDomainId' as const;
export const AuthHttpPatchSystemDomainsBySystemDomainId =
  'AuthHttpPatchSystemDomainsBySystemDomainId' as const;
export const AuthHttpPutSystemDomainsBySystemDomainId =
  'AuthHttpPutSystemDomainsBySystemDomainId' as const;
export const AuthHttpDeleteSystemDomainsBySystemDomainIdE2E =
  'AuthHttpDeleteSystemDomainsBySystemDomainIdE2E' as const;
export const AuthHttpPostSystemDomainsBySystemDomainIdFeatures =
  'AuthHttpPostSystemDomainsBySystemDomainIdFeatures' as const;
export const AuthHttpDeleteSystemDomainsBySystemDomainIdLogo =
  'AuthHttpDeleteSystemDomainsBySystemDomainIdLogo' as const;
export const AuthHttpPostSystemDomainsBySystemDomainIdLogo =
  'AuthHttpPostSystemDomainsBySystemDomainIdLogo' as const;
export const AuthHttpPatchSystemDomainsBySystemDomainIdProfile =
  'AuthHttpPatchSystemDomainsBySystemDomainIdProfile' as const;
export const AuthHttpPostSystemDomainsBySystemDomainIdReindex =
  'AuthHttpPostSystemDomainsBySystemDomainIdReindex' as const;

export type AuthIdentityProviderSchema =
  | {
      date_created?: string;
      date_modified?: string;
      id?: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthOneloginSettingsSchema;
      type: 'onelogin.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id?: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthAuth0SettingsSchema;
      type: 'auth0.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id?: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthOktaSettingsSchema;
      type: 'okta.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id?: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthGenericSettingsSchema;
      type: 'GENERIC';
      verbose_logging?: boolean;
    };
export type AuthIdentityProviderSchemaWithIdNullable =
  | {
      date_created?: string | null;
      date_modified?: string | null;
      id: string;
      public_id?: string | null;
      saml_settings?: {
        [k: string]: unknown;
      } | null;
      settings: AuthOneloginSettingsSchema;
      type: 'onelogin.com';
      verbose_logging?: boolean | null;
    }
  | {
      date_created?: string | null;
      date_modified?: string | null;
      id: string;
      public_id?: string | null;
      saml_settings?: {
        [k: string]: unknown;
      } | null;
      settings: AuthAuth0SettingsSchema;
      type: 'auth0.com';
      verbose_logging?: boolean | null;
    }
  | {
      date_created?: string | null;
      date_modified?: string | null;
      id: string;
      public_id?: string | null;
      saml_settings?: {
        [k: string]: unknown;
      } | null;
      settings: AuthOktaSettingsSchema;
      type: 'okta.com';
      verbose_logging?: boolean | null;
    }
  | {
      date_created?: string | null;
      date_modified?: string | null;
      id: string;
      public_id?: string | null;
      saml_settings?: {
        [k: string]: unknown;
      } | null;
      settings: AuthGenericSettingsSchema;
      type: 'GENERIC';
      verbose_logging?: boolean | null;
    };
export type AuthIdentityProviderSchemaWithId =
  | {
      date_created?: string;
      date_modified?: string;
      id: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthOneloginSettingsSchema;
      type: 'onelogin.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthAuth0SettingsSchema;
      type: 'auth0.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthOktaSettingsSchema;
      type: 'okta.com';
      verbose_logging?: boolean;
    }
  | {
      date_created?: string;
      date_modified?: string;
      id: string;
      public_id?: string;
      saml_settings?: {
        [k: string]: unknown;
      };
      settings: AuthGenericSettingsSchema;
      type: 'GENERIC';
      verbose_logging?: boolean;
    };

/**
 * Original schema `AppCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppCreateSchema}
 */
export interface AuthAppCreateSchema {
  allowed_origins?: string[];
  allowed_scopes?: string[];
  client_secret?: string;
  date_created?: string;
  date_modified?: string;
  default_user_id?: string | null;
  description?: string | null;
  id?: string;
  name: string;
  oauth_client_type?: ('public' | 'confidential') | null;
  redirect_uris?: string[];
  system_domain_id?: string;
  type?: 'PAT' | 'OAUTH';
  url?: string | null;
}
/**
 * Original schema `AppSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppSchema}
 */
export interface AuthAppSchema {
  allowed_origins?: string[];
  allowed_scopes?: string[];
  date_created?: string;
  date_modified?: string;
  default_user_id?: string | null;
  description?: string | null;
  id?: string;
  name: string;
  oauth_client_type?: ('public' | 'confidential') | null;
  redirect_uris?: string[];
  system_domain_id?: string;
  type?: 'PAT' | 'OAUTH';
  url?: string | null;
}
/**
 * Original schema `ApprovedAppInstanceSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ApprovedAppInstanceSchema}
 */
export interface AuthApprovedAppInstanceSchema {
  app_id: string;
  date_created?: string;
  id: string;
}
/**
 * Original schema `AppsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppsSchema}
 */
export interface AuthAppsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthAppSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `Auth0SettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-Auth0SettingsSchema}
 */
export interface AuthAuth0SettingsSchema {
  auth0_client_id: string;
  auth0_name: string;
  auth0_region: string;
  cert_fingerprint?: string;
  cert_fingerprint_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  digest_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  domain_name?: string;
  idp_x509cert?: string;
  signature_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#dsa-sha1'
    | 'http://www.w3.org/2000/09/xmldsig#rsa-sha1'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha384'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512';
}
/**
 * Original schema `AutoLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AutoLoginSchema}
 */
export interface AuthAutoLoginSchema {
  app_id: string;
  token: string;
}
/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-BaseQueryParamsSchema}
 */
export interface AuthBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A semicolon separated list of `field,order` pairs (name,asc;type,desc).
   */
  sort?: string;
}
/**
 * Original schema `BasicBillingLimitsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-BasicBillingLimitsSchema}
 */
export interface AuthBasicBillingLimitsSchema {
  max_portals?: number | null;
}
/**
 * Original schema `BillingLimitsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-BillingLimitsSchema}
 */
export interface AuthBillingLimitsSchema {
  ai_credits?: number | null;
  ai_object_detection_hours?: number | null;
  automation_tasks?: number | null;
  browse_users?: number | null;
  edge_transcoders?: number | null;
  egress_gb?: number | null;
  face_recognition_hours?: number | null;
  face_recognition_images?: number | null;
  image_recognition?: number | null;
  max_portals?: number | null;
  max_storage_gateway_clusters?: number | null;
  max_storage_gateway_nodes?: number | null;
  multiregion_storage_gb?: number | null;
  power_users?: number | null;
  proxy_storage_gb?: number | null;
  regional_storage_gb?: number | null;
  shield_enabled?: boolean | null;
  standard_users?: number | null;
  sync_session_max_clients?: number | null;
  transcription_hours?: number | null;
}
/**
 * Original schema `CompleteInvitationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CompleteInvitationSchema}
 */
export interface AuthCompleteInvitationSchema {
  email_marketing_consent?: boolean | null;
  first_name?: string | null;
  last_name?: string | null;
  password: string;
  repeat_password: string;
}
/**
 * Original schema `CountriesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CountriesSchema}
 */
export interface AuthCountriesSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthCountry[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `Country`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-Country}
 */
export interface AuthCountry {
  alpha2?: string;
  alpha3?: string;
  apolitical_name?: string;
  name: string;
  numeric?: string;
}
/**
 * Original schema `CountrySchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CountrySchema}
 */
export interface AuthCountrySchema {
  alpha2?: string;
  alpha3?: string;
  apolitical_name?: string;
  name: string;
  numeric?: string;
}
/**
 * Original schema `CuttingRoomErrorSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CuttingRoomErrorSchema}
 */
export interface AuthCuttingRoomErrorSchema {
  code?: string;
  message?: string;
}
/**
 * Original schema `CuttingRoomTokenResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CuttingRoomTokenResponseSchema}
 */
export interface AuthCuttingRoomTokenResponseSchema {
  access_token?: string;
  expires_in?: string;
  refresh_expires_in?: string;
  refresh_token?: string;
  token_type?: 'Bearer';
}
/**
 * Original schema `DomainIdentityProviderMapSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-DomainIdentityProviderMapSchema}
 */
export interface AuthDomainIdentityProviderMapSchema {
  domain: string;
  identity_provider_id: string;
  system_domain_id: string;
}
/**
 * Original schema `EmailLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-EmailLoginSchema}
 */
export interface AuthEmailLoginSchema {
  app_name?: string;
  email: string;
}
/**
 * Original schema `EmbedTokenRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-EmbedTokenRequestSchema}
 */
export interface AuthEmbedTokenRequestSchema {
  app_id?: string;
  app_name?: string;
}
/**
 * Original schema `EmbedTokenResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-EmbedTokenResponseSchema}
 */
export interface AuthEmbedTokenResponseSchema {
  app_id?: string;
  embed_token?: string;
  expires?: string;
}
/**
 * Original schema `EnableSystemDomainFeatureSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-EnableSystemDomainFeatureSchema}
 */
export interface AuthEnableSystemDomainFeatureSchema {
  config: AuthPublishFeature;
}
/**
 * Original schema `PublishFeature`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-PublishFeature}
 */
export interface AuthPublishFeature {
  feature: 'WM_PUBLISH_PANEL';
  parameters: AuthPublishFeatureParameters;
}
/**
 * Original schema `PublishFeatureParameters`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-PublishFeatureParameters}
 */
export interface AuthPublishFeatureParameters {
  /**
   * Wildmoka region, must be explicitly set to US or EU
   */
  region: 'US' | 'EU';
  salesforce_id: string;
}
/**
 * Original schema `ExternalAuthRequestResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ExternalAuthRequestResponseSchema}
 */
export interface AuthExternalAuthRequestResponseSchema {
  app_id?: string;
  redirect_info?: AuthRedirectInfoType;
}
/**
 * Original schema `RedirectInfoType`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-RedirectInfoType}
 */
export interface AuthRedirectInfoType {
  headers?: {
    [k: string]: unknown;
  } | null;
  url?: string | null;
}
/**
 * Original schema `ExternalAuthRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ExternalAuthRequestSchema}
 */
export interface AuthExternalAuthRequestSchema {
  app_id?: string;
  app_name?: string;
  redirect_info?: AuthRedirectInfoType | null;
  secret: string;
}
/**
 * Original schema `ExternalAuthSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ExternalAuthSchema}
 */
export interface AuthExternalAuthSchema {
  app_id?: string;
  date_created?: string;
  redirect_info?: AuthRedirectInfoType;
  token?: string;
}
/**
 * Original schema `ForgotPasswordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ForgotPasswordSchema}
 */
export interface AuthForgotPasswordSchema {
  email: string;
  reset_hash?: string | null;
}
/**
 * Original schema `GenericSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-GenericSettingsSchema}
 */
export interface AuthGenericSettingsSchema {
  cert_fingerprint?: string;
  cert_fingerprint_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  digest_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  domain_name?: string;
  idp_entity_id: string;
  idp_sls_redirect_url?: string;
  idp_sso_post_url: string;
  idp_x509cert?: string;
  name: string;
  name_id_encrypted?: boolean;
  signature_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#dsa-sha1'
    | 'http://www.w3.org/2000/09/xmldsig#rsa-sha1'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha384'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512';
  want_assertions_signed?: boolean;
  want_messages_signed?: boolean;
}
/**
 * Original schema `IconikTokenResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-IconikTokenResponseSchema}
 */
export interface AuthIconikTokenResponseSchema {
  expires?: string;
  refresh_token?: string;
  token?: string;
}
/**
 * Original schema `IdentityProviderBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-IdentityProviderBaseSchema}
 */
export interface AuthIdentityProviderBaseSchema {
  saml_settings?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `IdentityProviderBaseSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-IdentityProviderBaseSettingsSchema}
 */
export interface AuthIdentityProviderBaseSettingsSchema {
  cert_fingerprint?: string;
  cert_fingerprint_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  digest_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  domain_name?: string;
  idp_x509cert?: string;
  signature_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#dsa-sha1'
    | 'http://www.w3.org/2000/09/xmldsig#rsa-sha1'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha384'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512';
}
/**
 * Original schema `OneloginSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OneloginSettingsSchema}
 */
export interface AuthOneloginSettingsSchema {
  cert_fingerprint?: string;
  cert_fingerprint_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  digest_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  domain_name?: string;
  idp_x509cert?: string;
  onelogin_client_id: string;
  onelogin_name: string;
  signature_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#dsa-sha1'
    | 'http://www.w3.org/2000/09/xmldsig#rsa-sha1'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha384'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512';
}
/**
 * Original schema `OktaSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OktaSettingsSchema}
 */
export interface AuthOktaSettingsSchema {
  cert_fingerprint?: string;
  cert_fingerprint_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  digest_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#sha1'
    | 'http://www.w3.org/2001/04/xmlenc#sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#sha384'
    | 'http://www.w3.org/2001/04/xmlenc#sha512';
  domain_name?: string;
  idp_x509cert?: string;
  okta_app_id?: string;
  okta_name: string;
  okta_preview?: boolean;
  okta_sso?: string;
  signature_algorithm?:
    | 'http://www.w3.org/2000/09/xmldsig#dsa-sha1'
    | 'http://www.w3.org/2000/09/xmldsig#rsa-sha1'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha256'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha384'
    | 'http://www.w3.org/2001/04/xmldsig-more#rsa-sha512';
}
/**
 * Original schema `IdentityProvidersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-IdentityProvidersSchema}
 */
export interface AuthIdentityProvidersSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthIdentityProviderSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `InternalAuthenticateUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-InternalAuthenticateUserSchema}
 */
export interface AuthInternalAuthenticateUserSchema {
  app_name: string;
  marketplace_signup_nonce?: string;
  user: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `InternalTempTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-InternalTempTokenSchema}
 */
export interface AuthInternalTempTokenSchema {
  email: string;
  expires_in: number;
}
/**
 * Original schema `InvitationResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-InvitationResponseSchema}
 */
export interface AuthInvitationResponseSchema {
  auto_login?: boolean;
  domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  login_data?: AuthAutoLoginSchema;
  user_id?: string;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ListObjectsSchema}
 */
export interface AuthListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MarketplaceGoogleLinkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MarketplaceGoogleLinkSchema}
 */
export interface AuthMarketplaceGoogleLinkSchema {
  marketplace_signup_nonce: string;
}
/**
 * Original schema `MarketplaceGoogleSignupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MarketplaceGoogleSignupSchema}
 */
export interface AuthMarketplaceGoogleSignupSchema {
  'x-gcp-marketplace-token'?: string;
}
/**
 * Original schema `MultiDomainLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiDomainLoginSchema}
 */
export interface AuthMultiDomainLoginSchema {
  app_name?: string;
  email: string;
  marketplace_signup_nonce?: string;
  otp?: string | null;
  otp_type?: string | null;
  system_domain_id: string;
}
/**
 * Original schema `MultiDomainUserSystemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiDomainUserSystemSchema}
 */
export interface AuthMultiDomainUserSystemSchema {
  logo_url?: string;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[];
  mfa_methods_configured?: ('TOTP' | 'MAIL_2SV')[];
  mfa_required?: boolean;
  mfa_required_configured?: boolean;
  platform_url?: string;
  system_domain_id: string;
  system_domain_name?: string;
  url?: string;
}
/**
 * Original schema `MultiDomainUserSystemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiDomainUserSystemsSchema}
 */
export interface AuthMultiDomainUserSystemsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthMultiDomainUserSystemSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MultiPlatformDomainUserSystemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiPlatformDomainUserSystemSchema}
 */
export interface AuthMultiPlatformDomainUserSystemSchema {
  logo_url?: string;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[];
  mfa_methods_configured?: ('TOTP' | 'MAIL_2SV')[];
  mfa_required?: boolean;
  mfa_required_configured?: boolean;
  platform_url?: string;
  system_domain_id: string;
  system_domain_name?: string;
  token: string;
  url?: string;
}
/**
 * Original schema `NotifyOTPConfigurationChangedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-NotifyOTPConfigurationChangedSchema}
 */
export interface AuthNotifyOTPConfigurationChangedSchema {
  email: string;
  message_type:
    | 'otp_enabled'
    | 'otp_disabled'
    | 'totp_enabled'
    | 'totp_disabled';
  metadata?: {
    [k: string]: unknown;
  } | null;
}
/**
 * Original schema `NotifySystemDomainOTPConfigurationChangedSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-NotifySystemDomainOTPConfigurationChangedSchema}
 */
export interface AuthNotifySystemDomainOTPConfigurationChangedSchema {
  message_type:
    | 'otp_enabled'
    | 'otp_disabled'
    | 'totp_enabled'
    | 'totp_disabled';
  metadata?: {
    [k: string]: unknown;
  } | null;
  user_id: string;
}
/**
 * Original schema `OAuth2AuthorizeClientSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeClientSchema}
 */
export interface AuthOAuth2AuthorizeClientSchema {
  name: string;
}
/**
 * Original schema `OAuth2AuthorizeDescribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeDescribeSchema}
 */
export interface AuthOAuth2AuthorizeDescribeSchema {
  client: AuthOAuth2AuthorizeClientSchema;
  redirect_uri: string;
  scopes: string[];
  state?: string | null;
  system_domain: AuthOAuth2AuthorizeSystemDomain;
  user: AuthOAuth2AuthorizeUser;
}
/**
 * Original schema `OAuth2AuthorizeSystemDomain`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeSystemDomain}
 */
export interface AuthOAuth2AuthorizeSystemDomain {
  id: string;
  name: string;
}
/**
 * Original schema `OAuth2AuthorizeUser`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeUser}
 */
export interface AuthOAuth2AuthorizeUser {
  email: string;
  first_name?: string | null;
  id: string;
  last_name?: string | null;
  photo?: string | null;
}
/**
 * Original schema `OAuth2AuthorizeResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeResponseSchema}
 */
export interface AuthOAuth2AuthorizeResponseSchema {
  redirect_uri: string;
}
/**
 * Original schema `OAuth2AuthorizeSystemDomainSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeSystemDomainSchema}
 */
export interface AuthOAuth2AuthorizeSystemDomainSchema {
  id: string;
  name: string;
}
/**
 * Original schema `OAuth2AuthorizeUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeUserSchema}
 */
export interface AuthOAuth2AuthorizeUserSchema {
  email: string;
  first_name?: string | null;
  id: string;
  last_name?: string | null;
  photo?: string | null;
}
/**
 * Original schema `OAuthScopesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuthScopesSchema}
 */
export interface AuthOAuthScopesSchema {
  scopes?: string[];
}
/**
 * Original schema `PasswordChecksSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-PasswordChecksSchema}
 */
export interface AuthPasswordChecksSchema {
  digits?: number | null;
  lowercase?: number | null;
  max_length?: number | null;
  min_length?: number | null;
  special_symbols?: number | null;
  uppercase?: number | null;
}
/**
 * Original schema `PublishFeatureSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-PublishFeatureSchema}
 */
export interface AuthPublishFeatureSchema {
  feature: 'WM_PUBLISH_PANEL';
  parameters: AuthPublishFeatureParameters;
}
/**
 * Original schema `RedirectInfoTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-RedirectInfoTypeSchema}
 */
export interface AuthRedirectInfoTypeSchema {
  headers?: {
    [k: string]: unknown;
  } | null;
  url?: string | null;
}
/**
 * Original schema `ReferralCodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ReferralCodeSchema}
 */
export interface AuthReferralCodeSchema {
  billing_tier?:
    | (
        | 'PAYGO'
        | 'PRO'
        | 'ENTERPRISE'
        | 'ENTERPRISE_LEGACY_2025'
        | 'PRO_LEGACY_2025'
      )
    | null;
  code: string;
  credit_expiry_days?: number | null;
  do_not_delete?: boolean | null;
  freeze_date?: string | null;
  is_plg?: boolean | null;
  manage_system_domain_id?: string | null;
  ordway_customer_id?: string | null;
  sales_force_id?: string | null;
  valid_to: string;
  value: number;
}
/**
 * Original schema `ReferralCodesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ReferralCodesSchema}
 */
export interface AuthReferralCodesSchema {
  objects?: AuthReferralCodeSchema[];
}
/**
 * Original schema `RegistrationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-RegistrationSchema}
 */
export interface AuthRegistrationSchema {
  base_url?: string;
  company_name?: string | null;
  country: string;
  date_created?: string;
  email: string;
  email_marketing_consent?: boolean | null;
  first_name: string;
  id?: string;
  last_name: string;
  marketplace_signup_nonce?: string;
  ordway_customer_id?: string;
  ordway_subscription_id?: string;
  password: string;
  referral_code?: string;
  stripe_id?: string;
}
/**
 * Original schema `ReindexSystemDomainSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ReindexSystemDomainSchema}
 */
export interface AuthReindexSystemDomainSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ResetPasswordSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ResetPasswordSchema}
 */
export interface AuthResetPasswordSchema {
  password: string;
  repeat_password: string;
}
/**
 * Original schema `SAMLLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SAMLLoginSchema}
 */
export interface AuthSAMLLoginSchema {
  email: string;
}
/**
 * Original schema `SCIMConfig`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfig}
 */
export interface AuthSCIMConfig {
  adopt_existing_groups?: boolean;
  app_id?: string;
  date_created?: string;
  date_modified?: string;
  enabled?: boolean;
  id?: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string;
  system_domain_id?: string;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMConfigListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfigListSchema}
 */
export interface AuthSCIMConfigListSchema {
  objects?: AuthSCIMConfig[];
}
/**
 * Original schema `SCIMConfigSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfigSchema}
 */
export interface AuthSCIMConfigSchema {
  adopt_existing_groups?: boolean;
  app_id?: string;
  date_created?: string;
  date_modified?: string;
  enabled?: boolean;
  id?: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string;
  system_domain_id?: string;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMGroupRefusalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMGroupRefusalSchema}
 */
export interface AuthSCIMGroupRefusalSchema {
  identity_provider_id?: string | null;
  reason?: string;
  scim_config_id?: string | null;
  scim_config_name?: string | null;
}
/**
 * Original schema `SCIMManagedGroup`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroup}
 */
export interface AuthSCIMManagedGroup {
  date_created?: string;
  description?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP' | null) | null;
  id?: string;
  name?: string;
  scim_created?: boolean;
}
/**
 * Original schema `SCIMManagedGroupListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroupListSchema}
 */
export interface AuthSCIMManagedGroupListSchema {
  objects?: AuthSCIMManagedGroup[];
}
/**
 * Original schema `SCIMManagedGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroupSchema}
 */
export interface AuthSCIMManagedGroupSchema {
  date_created?: string;
  description?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP' | null) | null;
  id?: string;
  name?: string;
  scim_created?: boolean;
}
/**
 * Original schema `SCIMMarkGroupsRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMMarkGroupsRequestSchema}
 */
export interface AuthSCIMMarkGroupsRequestSchema {
  /**
   * @minItems 1
   */
  group_ids: string[];
}
/**
 * Original schema `SCIMMarkGroupsResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMMarkGroupsResponseSchema}
 */
export interface AuthSCIMMarkGroupsResponseSchema {
  marked?: string[];
  refused?: {
    [k: string]: AuthSCIMGroupRefusalSchema;
  };
}
/**
 * Original schema `SCIMTokenRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMTokenRequestSchema}
 */
export interface AuthSCIMTokenRequestSchema {
  expires_in_days?: number;
}
/**
 * Original schema `SCIMTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMTokenSchema}
 */
export interface AuthSCIMTokenSchema {
  token?: string;
  token_expires?: string;
  token_id?: string;
}
/**
 * Original schema `SimpleLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SimpleLoginSchema}
 */
export interface AuthSimpleLoginSchema {
  app_name?: string;
  email: string;
  marketplace_signup_nonce?: string;
  password: string;
}
/**
 * Original schema `SystemDomainBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainBaseSchema}
 */
export interface AuthSystemDomainBaseSchema {}
/**
 * Original schema `SystemDomainBasicAdminSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainBasicAdminSchema}
 */
export interface AuthSystemDomainBasicAdminSchema {
  billing_limits?: AuthBasicBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  contract_end_date?: string;
  country?: string;
  date_created?: string;
  features?: string[];
  freeze_date?: string;
  id?: string;
  is_plg?: boolean;
  name: string;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
}
/**
 * Original schema `SystemDomainBasicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainBasicSchema}
 */
export interface AuthSystemDomainBasicSchema {
  billing_limits?: AuthBasicBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  country?: string;
  date_created?: string;
  features?: string[];
  id?: string;
  is_plg?: boolean;
  name: string;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
}
/**
 * Original schema `SystemDomainFromReferralCodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainFromReferralCodeSchema}
 */
export interface AuthSystemDomainFromReferralCodeSchema {
  admin_email?: string;
  admin_first_name?: string;
  admin_last_name?: string;
  admin_password?: string;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  country_code: string;
  date_created?: string;
  date_modified?: string;
  description?: string;
  id?: string;
  name: string;
}
/**
 * Original schema `SystemDomainFromTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainFromTemplateSchema}
 */
export interface AuthSystemDomainFromTemplateSchema {
  admin_email?: string;
  admin_first_name?: string;
  admin_id?: string;
  admin_last_name?: string;
  admin_password?: string;
  base_url?: string;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  custom_terms?: boolean;
  date_created?: string;
  date_modified?: string;
  description?: string;
  /**
   * Opt the new domain out of every AI feature.
   */
  disable_ai_features?: boolean;
  id?: string;
  name: string;
  status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
}
/**
 * Original schema `SystemDomainProfileSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainProfileSchema}
 */
export interface AuthSystemDomainProfileSchema {
  industry?:
    | 'ADVERTISING_MARKETING_CREATIVE'
    | 'AUTOMOTIVE'
    | 'BROADCASTER_NETWORKS'
    | 'CONSTRUCTION_MANUFACTURING'
    | 'EDUCATION'
    | 'ENERGY_UTILITIES'
    | 'FAITH_RELIGIOUS_ORGS'
    | 'FINANCE'
    | 'GAME_STUDIOS_PUBLISHERS'
    | 'GOVERNMENT_PUBLIC_SECTOR'
    | 'HEALTHCARE'
    | 'HOSPITALITY_FITNESS_WELLNESS'
    | 'LIVE_PRODUCTION_EVENTS'
    | 'MEDIA_CONGLOMERATES'
    | 'NONPROFITS_NON_RELIGIOUS'
    | 'ONLINE_MEDIA'
    | 'PUBLISHERS_NEWSPAPERS'
    | 'TELECOMMUNICATIONS'
    | 'RETAIL_CONSUMER_GOODS'
    | 'SOFTWARE_TECHNOLOGY'
    | 'SPORTS_RIGHTS_LEAGUES'
    | 'STUDIOS_CONTENT_PRODUCERS'
    | 'OTHER';
}
/**
 * Original schema `SystemDomainSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainSchema}
 */
export interface AuthSystemDomainSchema {
  base_url: string;
  billing_limits?: AuthBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  contract_end_date?: string;
  country?: string;
  creating_user_id?: string;
  custom_terms?: boolean;
  date_created?: string;
  date_modified?: string;
  deactivate_date?: string;
  description?: string;
  disable_ai_features?: boolean;
  disable_billing_page?: boolean;
  disable_cc_purchase?: boolean;
  discount_percent?: number;
  do_not_charge_edge_transcoder?: boolean;
  do_not_charge_remote_proxies?: boolean;
  do_not_charge_shield?: boolean;
  do_not_trace_ai_usage?: boolean;
  features?: string[];
  freeze_date?: string;
  has_preloaded_assets?: boolean;
  id?: string;
  industry?:
    | 'ADVERTISING_MARKETING_CREATIVE'
    | 'AUTOMOTIVE'
    | 'BROADCASTER_NETWORKS'
    | 'CONSTRUCTION_MANUFACTURING'
    | 'EDUCATION'
    | 'ENERGY_UTILITIES'
    | 'FAITH_RELIGIOUS_ORGS'
    | 'FINANCE'
    | 'GAME_STUDIOS_PUBLISHERS'
    | 'GOVERNMENT_PUBLIC_SECTOR'
    | 'HEALTHCARE'
    | 'HOSPITALITY_FITNESS_WELLNESS'
    | 'LIVE_PRODUCTION_EVENTS'
    | 'MEDIA_CONGLOMERATES'
    | 'NONPROFITS_NON_RELIGIOUS'
    | 'ONLINE_MEDIA'
    | 'PUBLISHERS_NEWSPAPERS'
    | 'TELECOMMUNICATIONS'
    | 'RETAIL_CONSUMER_GOODS'
    | 'SOFTWARE_TECHNOLOGY'
    | 'SPORTS_RIGHTS_LEAGUES'
    | 'STUDIOS_CONTENT_PRODUCERS'
    | 'OTHER';
  invoice_end_of_month?: boolean;
  is_plg?: boolean;
  is_template?: boolean;
  licensed_user_billing?: boolean;
  marketplace_customer_id?: string;
  marketplace_entitlement_id?: string;
  name: string;
  ordway_customer_id?: string;
  ordway_subscription_id?: string;
  platform_name?: string;
  price_list?: string;
  primary_region?: string;
  referral_code?: string;
  sales_force_id?: string;
  status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  stripe_id?: string;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
  warning_message?: string;
}
/**
 * Original schema `SystemDomainSuperAdminSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainSuperAdminSchema}
 */
export interface AuthSystemDomainSuperAdminSchema {
  base_url: string;
  billing_limits?: AuthBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  contract_end_date?: string | null;
  country?: string | null;
  creating_user_id?: string | null;
  custom_terms?: boolean;
  date_created?: string;
  date_modified?: string;
  deactivate_date?: string | null;
  description?: string;
  disable_ai_features?: boolean;
  disable_billing_page?: boolean;
  disable_cc_purchase?: boolean;
  discount_percent?: number | null;
  do_not_charge_edge_transcoder?: boolean;
  do_not_charge_remote_proxies?: boolean;
  do_not_charge_shield?: boolean;
  do_not_trace_ai_usage?: boolean;
  features?: string[];
  freeze_date?: string | null;
  has_preloaded_assets?: boolean;
  id?: string;
  industry?:
    | 'ADVERTISING_MARKETING_CREATIVE'
    | 'AUTOMOTIVE'
    | 'BROADCASTER_NETWORKS'
    | 'CONSTRUCTION_MANUFACTURING'
    | 'EDUCATION'
    | 'ENERGY_UTILITIES'
    | 'FAITH_RELIGIOUS_ORGS'
    | 'FINANCE'
    | 'GAME_STUDIOS_PUBLISHERS'
    | 'GOVERNMENT_PUBLIC_SECTOR'
    | 'HEALTHCARE'
    | 'HOSPITALITY_FITNESS_WELLNESS'
    | 'LIVE_PRODUCTION_EVENTS'
    | 'MEDIA_CONGLOMERATES'
    | 'NONPROFITS_NON_RELIGIOUS'
    | 'ONLINE_MEDIA'
    | 'PUBLISHERS_NEWSPAPERS'
    | 'TELECOMMUNICATIONS'
    | 'RETAIL_CONSUMER_GOODS'
    | 'SOFTWARE_TECHNOLOGY'
    | 'SPORTS_RIGHTS_LEAGUES'
    | 'STUDIOS_CONTENT_PRODUCERS'
    | 'OTHER';
  invoice_end_of_month?: boolean;
  is_plg?: boolean;
  is_template?: boolean;
  licensed_user_billing?: boolean;
  marketplace_customer_id?: string | null;
  marketplace_entitlement_id?: string | null;
  name: string;
  ordway_customer_id?: string | null;
  ordway_subscription_id?: string | null;
  platform_name?: string;
  price_list?: string | null;
  referral_code?: string | null;
  sales_force_id?: string | null;
  status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  stripe_id?: string | null;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
  warning_message?: string;
}
/**
 * Original schema `SystemDomainWildmokaConfigSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainWildmokaConfigSchema}
 */
export interface AuthSystemDomainWildmokaConfigSchema {
  /**
   * Wildmoka API endpoint URL
   */
  api_base_url?: string | null;
  /**
   * JWT issuer to use for authentication
   */
  issuer?: string | null;
  /**
   * AWS IAM role ARN for Wildmoka S3 access
   */
  role_arn?: string | null;
  /**
   * JWT secret key to use for authentication
   */
  secret_key?: string | null;
  /**
   * Wildmoka UI endpoint URL
   */
  ui_base_url?: string | null;
}
/**
 * Original schema `SystemDomainWithBillingLimitsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainWithBillingLimitsSchema}
 */
export interface AuthSystemDomainWithBillingLimitsSchema {}
/**
 * Original schema `SystemDomainsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainsQueryParamsSchema}
 */
export interface AuthSystemDomainsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A semicolon separated list of `field,order` pairs (name,asc;type,desc).
   */
  sort?: string;
}
/**
 * Original schema `SystemDomainsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainsSchema}
 */
export interface AuthSystemDomainsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthSystemDomainSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `TemporaryPasswordTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TemporaryPasswordTokenSchema}
 */
export interface AuthTemporaryPasswordTokenSchema {
  date_created?: string;
  date_modified?: string;
  email: string;
  expires?: string;
  id?: string;
  token: string;
}
/**
 * Original schema `TokenBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenBaseSchema}
 */
export interface AuthTokenBaseSchema {
  app_id?: string;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id?: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  user_id?: string;
}
/**
 * Original schema `TokenExchangeRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenExchangeRequestSchema}
 */
export interface AuthTokenExchangeRequestSchema {
  embed_token: string;
  requested_scopes?: string[];
}
/**
 * Original schema `TokenMultiplatformLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenMultiplatformLoginSchema}
 */
export interface AuthTokenMultiplatformLoginSchema {
  app_id?: string;
  auth_system_domains?: AuthMultiPlatformDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id?: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  /**
   * Deprecated field. Use the token field from the `auth_system_domains` items instead.
   */
  token?: string | null;
  user_id?: string;
}
/**
 * Original schema `TokenOutputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenOutputSchema}
 */
export interface AuthTokenOutputSchema {
  app_id?: string;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id?: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  user_id?: string;
}
/**
 * Original schema `TokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenSchema}
 */
export interface AuthTokenSchema {
  app_id?: string;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id?: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  token: string;
  user_id?: string;
}
/**
 * Original schema `TokensSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokensSchema}
 */
export interface AuthTokensSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: AuthTokenOutputSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `UserSystemDomainInviteSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-UserSystemDomainInviteSchema}
 */
export interface AuthUserSystemDomainInviteSchema {
  id: string;
  is_existing_user_invitation?: boolean;
  is_initial_user_invitation?: boolean;
  system_domain_id: string;
}
/**
 * Original schema `VerificationResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-VerificationResponseSchema}
 */
export interface AuthVerificationResponseSchema {
  auto_login?: boolean;
  domain_data?: AuthSystemDomainFromTemplateSchema;
  login_data?: AuthAutoLoginSchema;
}
/**
 * Original schema `VerifyInviteByLinkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-VerifyInviteByLinkSchema}
 */
export interface AuthVerifyInviteByLinkSchema {
  inviter_email: string;
  local_user_exists: boolean;
  new_user_email: string;
  new_user_first_name: string;
  system_domain_id: string;
}
/**
 * Original schema `WebflowContentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-WebflowContentSchema}
 */
export interface AuthWebflowContentSchema {
  caption?: string;
  category?: string;
  image?: string;
  name?: string;
  slug: string;
}
/**
 * Original schema `_SystemDomainFeatureSchemaBase`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-_SystemDomainFeatureSchemaBase}
 */
export interface Auth_SystemDomainFeatureSchemaBase {
  parameters?: {
    [k: string]: unknown;
  };
}
/**
 * Original schema `AppsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppsSchema}
 */
export interface AuthAppsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthAppSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `AppSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppSchema}
 */
export interface AuthAppSchemaWithIdNullable {
  allowed_origins?: string[] | null;
  allowed_scopes?: string[] | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_id?: string | null;
  description?: string | null;
  id: string;
  name: string;
  oauth_client_type?: ('public' | 'confidential') | null;
  redirect_uris?: string[] | null;
  system_domain_id?: string | null;
  type?: ('PAT' | 'OAUTH') | null;
  url?: string | null;
}
/**
 * Original schema `AppSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppSchema}
 */
export interface AuthAppSchemaWithId {
  allowed_origins?: string[];
  allowed_scopes?: string[];
  date_created?: string;
  date_modified?: string;
  default_user_id?: string | null;
  description?: string | null;
  id: string;
  name: string;
  oauth_client_type?: ('public' | 'confidential') | null;
  redirect_uris?: string[];
  system_domain_id?: string;
  type?: 'PAT' | 'OAUTH';
  url?: string | null;
}
/**
 * Original schema `AppCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-AppCreateSchema}
 */
export interface AuthAppCreateSchemaWithId {
  allowed_origins?: string[];
  allowed_scopes?: string[];
  client_secret?: string;
  date_created?: string;
  date_modified?: string;
  default_user_id?: string | null;
  description?: string | null;
  id: string;
  name: string;
  oauth_client_type?: ('public' | 'confidential') | null;
  redirect_uris?: string[];
  system_domain_id?: string;
  type?: 'PAT' | 'OAUTH';
  url?: string | null;
}
/**
 * Original schema `ExternalAuthSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ExternalAuthSchema}
 */
export interface AuthExternalAuthSchemaNullable {
  app_id?: string | null;
  date_created?: string | null;
  redirect_info?: AuthRedirectInfoType | null;
  token?: string | null;
}
/**
 * Original schema `OAuthScopesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuthScopesSchema}
 */
export interface AuthOAuthScopesSchemaNullable {
  scopes?: string[] | null;
}
/**
 * Original schema `TokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenSchema}
 */
export interface AuthTokenSchemaWithId {
  app_id?: string;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  token: string;
  user_id?: string;
}
/**
 * Original schema `IdentityProvidersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-IdentityProvidersSchema}
 */
export interface AuthIdentityProvidersSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthIdentityProviderSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `MultiDomainUserSystemsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiDomainUserSystemsSchema}
 */
export interface AuthMultiDomainUserSystemsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthMultiDomainUserSystemSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `MultiDomainUserSystemSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-MultiDomainUserSystemSchema}
 */
export interface AuthMultiDomainUserSystemSchemaNullable {
  logo_url?: string | null;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_methods_configured?: ('TOTP' | 'MAIL_2SV')[] | null;
  mfa_required?: boolean | null;
  mfa_required_configured?: boolean | null;
  platform_url?: string | null;
  system_domain_id: string;
  system_domain_name?: string | null;
  url?: string | null;
}
/**
 * Original schema `TokenMultiplatformLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenMultiplatformLoginSchema}
 */
export interface AuthTokenMultiplatformLoginSchemaWithId {
  app_id?: string;
  auth_system_domains?: AuthMultiPlatformDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  /**
   * Deprecated field. Use the token field from the `auth_system_domains` items instead.
   */
  token?: string | null;
  user_id?: string;
}
/**
 * Original schema `TokensSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokensSchema}
 */
export interface AuthTokensSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthTokenOutputSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `TokenOutputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenOutputSchema}
 */
export interface AuthTokenOutputSchemaWithIdNullable {
  app_id?: string | null;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[] | null;
  date_created?: string | null;
  date_modified?: string | null;
  expires?: string | null;
  id: string;
  is_admin?: boolean | null;
  is_mfa_authenticated?: boolean | null;
  is_saml_authenticated?: boolean | null;
  is_super_admin?: boolean | null;
  is_super_admin_light?: boolean | null;
  system_domain_id?: string | null;
  system_domain_is_plg?: boolean | null;
  system_domain_status?:
    | ('ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED')
    | null;
  system_domain_type?: string | null;
  system_domain_warning_message?: string | null;
  system_domains?: string[] | null;
  user_id?: string | null;
}
/**
 * Original schema `TokenOutputSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-TokenOutputSchema}
 */
export interface AuthTokenOutputSchemaWithId {
  app_id?: string;
  auth_system_domains?: AuthMultiDomainUserSystemSchema[];
  date_created?: string;
  date_modified?: string;
  expires?: string;
  id: string;
  is_admin?: boolean;
  is_mfa_authenticated?: boolean;
  is_saml_authenticated?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  system_domain_id?: string;
  system_domain_is_plg?: boolean;
  system_domain_status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  system_domain_type?: string;
  system_domain_warning_message?: string;
  system_domains?: string[];
  user_id?: string;
}
/**
 * Original schema `OAuth2AuthorizeDescribeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-OAuth2AuthorizeDescribeSchema}
 */
export interface AuthOAuth2AuthorizeDescribeSchemaNullable {
  client: AuthOAuth2AuthorizeClientSchema;
  redirect_uri: string;
  scopes: string[];
  state?: string | null;
  system_domain: AuthOAuth2AuthorizeSystemDomain;
  user: AuthOAuth2AuthorizeUser;
}
/**
 * Original schema `PasswordChecksSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-PasswordChecksSchema}
 */
export interface AuthPasswordChecksSchemaNullable {
  digits?: number | null;
  lowercase?: number | null;
  max_length?: number | null;
  min_length?: number | null;
  special_symbols?: number | null;
  uppercase?: number | null;
}
/**
 * Original schema `ReferralCodesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ReferralCodesSchema}
 */
export interface AuthReferralCodesSchemaWithId {
  objects: AuthReferralCodeSchemaNullable[];
}
/**
 * Original schema `ReferralCodeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-ReferralCodeSchema}
 */
export interface AuthReferralCodeSchemaNullable {
  billing_tier?:
    | (
        | 'PAYGO'
        | 'PRO'
        | 'ENTERPRISE'
        | 'ENTERPRISE_LEGACY_2025'
        | 'PRO_LEGACY_2025'
      )
    | null;
  code: string;
  credit_expiry_days?: number | null;
  do_not_delete?: boolean | null;
  freeze_date?: string | null;
  is_plg?: boolean | null;
  manage_system_domain_id?: string | null;
  ordway_customer_id?: string | null;
  sales_force_id?: string | null;
  valid_to: string;
  value: number;
}
/**
 * Original schema `RegistrationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-RegistrationSchema}
 */
export interface AuthRegistrationSchemaWithId {
  base_url?: string;
  company_name?: string | null;
  country: string;
  date_created?: string;
  email: string;
  email_marketing_consent?: boolean | null;
  first_name: string;
  id: string;
  last_name: string;
  marketplace_signup_nonce?: string;
  ordway_customer_id?: string;
  ordway_subscription_id?: string;
  password: string;
  referral_code?: string;
  stripe_id?: string;
}
/**
 * Original schema `WebflowContentSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-WebflowContentSchema}
 */
export interface AuthWebflowContentSchemaNullable {
  caption?: string | null;
  category?: string | null;
  image?: string | null;
  name?: string | null;
  slug: string;
}
/**
 * Original schema `CountriesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-CountriesSchema}
 */
export interface AuthCountriesSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthCountryNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `Country`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-Country}
 */
export interface AuthCountryNullable {
  alpha2?: string | null;
  alpha3?: string | null;
  apolitical_name?: string | null;
  name: string;
  numeric?: string | null;
}
/**
 * Original schema `SCIMConfigListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfigListSchema}
 */
export interface AuthSCIMConfigListSchemaWithId {
  objects: AuthSCIMConfigWithIdNullable[];
}
/**
 * Original schema `SCIMConfig`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfig}
 */
export interface AuthSCIMConfigWithIdNullable {
  adopt_existing_groups?: boolean | null;
  app_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  enabled?: boolean | null;
  id: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string | null;
  system_domain_id?: string | null;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMConfig`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfig}
 */
export interface AuthSCIMConfigWithId {
  adopt_existing_groups?: boolean;
  app_id?: string;
  date_created?: string;
  date_modified?: string;
  enabled?: boolean;
  id: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string;
  system_domain_id?: string;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMConfigSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfigSchema}
 */
export interface AuthSCIMConfigSchemaWithId {
  adopt_existing_groups?: boolean;
  app_id?: string;
  date_created?: string;
  date_modified?: string;
  enabled?: boolean;
  id: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string;
  system_domain_id?: string;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMConfigSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMConfigSchema}
 */
export interface AuthSCIMConfigSchemaWithIdNullable {
  adopt_existing_groups?: boolean | null;
  app_id?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  enabled?: boolean | null;
  id: string;
  identity_provider_id?: string | null;
  name?: string | null;
  scim_base_url?: string | null;
  system_domain_id?: string | null;
  token_date_created?: string | null;
  token_expires?: string | null;
  token_id?: string | null;
}
/**
 * Original schema `SCIMManagedGroupListSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroupListSchema}
 */
export interface AuthSCIMManagedGroupListSchemaWithId {
  objects: AuthSCIMManagedGroupWithIdNullable[];
}
/**
 * Original schema `SCIMManagedGroup`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroup}
 */
export interface AuthSCIMManagedGroupWithIdNullable {
  date_created?: string | null;
  description?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP' | null) | null;
  id: string;
  name?: string | null;
  scim_created?: boolean | null;
}
/**
 * Original schema `SCIMManagedGroup`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SCIMManagedGroup}
 */
export interface AuthSCIMManagedGroupWithId {
  date_created?: string;
  description?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP' | null) | null;
  id: string;
  name?: string;
  scim_created?: boolean;
}
/**
 * Original schema `SystemDomainsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainsSchema}
 */
export interface AuthSystemDomainsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: AuthSystemDomainSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `SystemDomainSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainSchema}
 */
export interface AuthSystemDomainSchemaWithIdNullable {
  base_url: string;
  billing_limits?: AuthBillingLimitsSchema | null;
  billing_tier?:
    | (
        | 'PAYGO'
        | 'PRO'
        | 'ENTERPRISE'
        | 'ENTERPRISE_LEGACY_2025'
        | 'PRO_LEGACY_2025'
      )
    | null;
  contract_end_date?: string | null;
  country?: string | null;
  creating_user_id?: string | null;
  custom_terms?: boolean | null;
  date_created?: string | null;
  date_modified?: string | null;
  deactivate_date?: string | null;
  description?: string | null;
  disable_ai_features?: boolean | null;
  disable_billing_page?: boolean | null;
  disable_cc_purchase?: boolean | null;
  discount_percent?: number | null;
  do_not_charge_edge_transcoder?: boolean | null;
  do_not_charge_remote_proxies?: boolean | null;
  do_not_charge_shield?: boolean | null;
  do_not_trace_ai_usage?: boolean | null;
  features?: string[] | null;
  freeze_date?: string | null;
  has_preloaded_assets?: boolean | null;
  id: string;
  industry?:
    | (
        | 'ADVERTISING_MARKETING_CREATIVE'
        | 'AUTOMOTIVE'
        | 'BROADCASTER_NETWORKS'
        | 'CONSTRUCTION_MANUFACTURING'
        | 'EDUCATION'
        | 'ENERGY_UTILITIES'
        | 'FAITH_RELIGIOUS_ORGS'
        | 'FINANCE'
        | 'GAME_STUDIOS_PUBLISHERS'
        | 'GOVERNMENT_PUBLIC_SECTOR'
        | 'HEALTHCARE'
        | 'HOSPITALITY_FITNESS_WELLNESS'
        | 'LIVE_PRODUCTION_EVENTS'
        | 'MEDIA_CONGLOMERATES'
        | 'NONPROFITS_NON_RELIGIOUS'
        | 'ONLINE_MEDIA'
        | 'PUBLISHERS_NEWSPAPERS'
        | 'TELECOMMUNICATIONS'
        | 'RETAIL_CONSUMER_GOODS'
        | 'SOFTWARE_TECHNOLOGY'
        | 'SPORTS_RIGHTS_LEAGUES'
        | 'STUDIOS_CONTENT_PRODUCERS'
        | 'OTHER'
      )
    | null;
  invoice_end_of_month?: boolean | null;
  is_plg?: boolean | null;
  is_template?: boolean | null;
  licensed_user_billing?: boolean | null;
  marketplace_customer_id?: string | null;
  marketplace_entitlement_id?: string | null;
  name: string;
  ordway_customer_id?: string | null;
  ordway_subscription_id?: string | null;
  platform_name?: string | null;
  price_list?: string | null;
  primary_region?: string | null;
  referral_code?: string | null;
  sales_force_id?: string | null;
  status?: ('ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED') | null;
  stripe_id?: string | null;
  type?: ('TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL') | null;
  warning_message?: string | null;
}
/**
 * Original schema `SystemDomainSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainSchema}
 */
export interface AuthSystemDomainSchemaWithId {
  base_url: string;
  billing_limits?: AuthBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  contract_end_date?: string;
  country?: string;
  creating_user_id?: string;
  custom_terms?: boolean;
  date_created?: string;
  date_modified?: string;
  deactivate_date?: string;
  description?: string;
  disable_ai_features?: boolean;
  disable_billing_page?: boolean;
  disable_cc_purchase?: boolean;
  discount_percent?: number;
  do_not_charge_edge_transcoder?: boolean;
  do_not_charge_remote_proxies?: boolean;
  do_not_charge_shield?: boolean;
  do_not_trace_ai_usage?: boolean;
  features?: string[];
  freeze_date?: string;
  has_preloaded_assets?: boolean;
  id: string;
  industry?:
    | 'ADVERTISING_MARKETING_CREATIVE'
    | 'AUTOMOTIVE'
    | 'BROADCASTER_NETWORKS'
    | 'CONSTRUCTION_MANUFACTURING'
    | 'EDUCATION'
    | 'ENERGY_UTILITIES'
    | 'FAITH_RELIGIOUS_ORGS'
    | 'FINANCE'
    | 'GAME_STUDIOS_PUBLISHERS'
    | 'GOVERNMENT_PUBLIC_SECTOR'
    | 'HEALTHCARE'
    | 'HOSPITALITY_FITNESS_WELLNESS'
    | 'LIVE_PRODUCTION_EVENTS'
    | 'MEDIA_CONGLOMERATES'
    | 'NONPROFITS_NON_RELIGIOUS'
    | 'ONLINE_MEDIA'
    | 'PUBLISHERS_NEWSPAPERS'
    | 'TELECOMMUNICATIONS'
    | 'RETAIL_CONSUMER_GOODS'
    | 'SOFTWARE_TECHNOLOGY'
    | 'SPORTS_RIGHTS_LEAGUES'
    | 'STUDIOS_CONTENT_PRODUCERS'
    | 'OTHER';
  invoice_end_of_month?: boolean;
  is_plg?: boolean;
  is_template?: boolean;
  licensed_user_billing?: boolean;
  marketplace_customer_id?: string;
  marketplace_entitlement_id?: string;
  name: string;
  ordway_customer_id?: string;
  ordway_subscription_id?: string;
  platform_name?: string;
  price_list?: string;
  primary_region?: string;
  referral_code?: string;
  sales_force_id?: string;
  status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  stripe_id?: string;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
  warning_message?: string;
}
/**
 * Original schema `SystemDomainBasicAdminSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainBasicAdminSchema}
 */
export interface AuthSystemDomainBasicAdminSchemaWithId {
  billing_limits?: AuthBasicBillingLimitsSchema | null;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  contract_end_date?: string;
  country?: string;
  date_created?: string;
  features?: string[];
  freeze_date?: string;
  id: string;
  is_plg?: boolean;
  name: string;
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
}
/**
 * Original schema `SystemDomainBasicAdminSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainBasicAdminSchema}
 */
export interface AuthSystemDomainBasicAdminSchemaWithIdNullable {
  billing_limits?: AuthBasicBillingLimitsSchema | null;
  billing_tier?:
    | (
        | 'PAYGO'
        | 'PRO'
        | 'ENTERPRISE'
        | 'ENTERPRISE_LEGACY_2025'
        | 'PRO_LEGACY_2025'
      )
    | null;
  contract_end_date?: string | null;
  country?: string | null;
  date_created?: string | null;
  features?: string[] | null;
  freeze_date?: string | null;
  id: string;
  is_plg?: boolean | null;
  name: string;
  type?: ('TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL') | null;
}
/**
 * Original schema `SystemDomainFromTemplateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#model-SystemDomainFromTemplateSchema}
 */
export interface AuthSystemDomainFromTemplateSchemaWithId {
  admin_email?: string;
  admin_first_name?: string;
  admin_id?: string;
  admin_last_name?: string;
  admin_password?: string;
  base_url?: string;
  billing_tier?:
    | 'PAYGO'
    | 'PRO'
    | 'ENTERPRISE'
    | 'ENTERPRISE_LEGACY_2025'
    | 'PRO_LEGACY_2025';
  custom_terms?: boolean;
  date_created?: string;
  date_modified?: string;
  description?: string;
  /**
   * Opt the new domain out of every AI feature.
   */
  disable_ai_features?: boolean;
  id: string;
  name: string;
  status?: 'ACTIVE' | 'WARNING' | 'FROZEN' | 'DEACTIVATED';
  type?: 'TRIAL' | 'CUSTOMER' | 'PARTNER' | 'INTERNAL';
}

export interface AuthHttpGetAppsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/apps/`
 *
 * List of apps
 *
 * Required roles:
 *  - can_read_apps
 *
 * Responses
 * - 200 - Returns a list of app
 * - 401 - Token is invalid
 *
 * Response {@link AuthAppsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_apps_}
 */
export const httpGetApps = (
  query?: AuthHttpGetAppsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetApps,
  method: httpMethod.get,
  url: '/API/auth/v1/apps/',

  query,
  headers,
});

/**
 * `POST /v1/apps/`
 *
 * Create a new app
 *
 * Required roles:
 *  - can_write_apps
 *
 * Responses
 * - 201 - Returns a created app
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthAppCreateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_apps_}
 */
export const httpPostApps = (
  body: AuthAppCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostApps,
  method: httpMethod.post,
  url: '/API/auth/v1/apps/',

  body,
  headers,
});

/**
 * `POST /v1/apps/external/auth/`
 *
 * Create a new token for the logged in user and store it for an external app
 *
 *
 * Responses
 * - 201 - Returns an app_id
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthExternalAuthRequestResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_apps_external_auth_}
 */
export const httpPostAppsExternalAuth = (
  body: AuthExternalAuthRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAppsExternalAuth,
  method: httpMethod.post,
  url: '/API/auth/v1/apps/external/auth/',

  body,
  headers,
});

/**
 * `GET /v1/apps/external/auth/{secret}/`
 *
 * Gets a token requested by an external app
 *
 *
 * Responses
 * - 200 - Returns auth info
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthExternalAuthSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_apps_external_auth__secret__}
 */
export const httpGetAppsExternalAuthBySecret = (
  secret: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAppsExternalAuthBySecret,
  method: httpMethod.get,
  url: `/API/auth/v1/apps/external/auth/${encodeURIComponent(secret)}/`,
  params: { secret },
  headers,
});

export type AuthApprovedAppInstanceSchemaOptionalId = PartialBy<
  AuthApprovedAppInstanceSchema,
  'id'
>;

/**
 * `POST /v1/apps/instance/`
 *
 * Create a new app instance
 *
 *
 * Responses
 * - 201 - Returns a created app
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthApprovedAppInstanceSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_apps_instance_}
 */
export const httpPostAppsInstance = (
  body: AuthApprovedAppInstanceSchemaOptionalId,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAppsInstance,
  method: httpMethod.post,
  url: '/API/auth/v1/apps/instance/',

  body,
  headers,
});

/**
 * `DELETE /v1/apps/instance/{approved_instance_id}/`
 *
 * Delete an approved instance of an app
 *
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_apps_instance__approved_instance_id__}
 */
export const httpDeleteAppsInstanceByApprovedInstanceId = (
  approvedInstanceId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteAppsInstanceByApprovedInstanceId,
  method: httpMethod.delete,
  url: `/API/auth/v1/apps/instance/${encodeURIComponent(approvedInstanceId)}/`,
  params: { approvedInstanceId },
  headers,
});

/**
 * `GET /v1/apps/instance/{approved_instance_id}/`
 *
 * Gets an approved instance of an app
 *
 *
 * Responses
 * - 200 - Returns auth info
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthExternalAuthSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_apps_instance__approved_instance_id__}
 */
export const httpGetAppsInstanceByApprovedInstanceId = (
  approvedInstanceId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAppsInstanceByApprovedInstanceId,
  method: httpMethod.get,
  url: `/API/auth/v1/apps/instance/${encodeURIComponent(approvedInstanceId)}/`,
  params: { approvedInstanceId },
  headers,
});

/**
 * `GET /v1/apps/oauth_scopes/`
 *
 * List of OAuth scopes currently supported by the platform
 *
 * Required roles:
 *  - can_read_apps
 *
 * Responses
 * - 200 - Returns the list of OAuth scopes an app's allowed_scopes may contain
 * - 401 - Token is invalid
 *
 * Response {@link AuthOAuthScopesSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_apps_oauth_scopes_}
 */
export const httpGetAppsOauthScopes = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetAppsOauthScopes,
  method: httpMethod.get,
  url: '/API/auth/v1/apps/oauth_scopes/',

  headers,
});

/**
 * `DELETE /v1/apps/{app_id}/`
 *
 * Delete a particular app by id
 *
 * Required roles:
 *  - can_delete_apps
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_apps__app_id__}
 */
export const httpDeleteAppsByAppId = (
  appId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteAppsByAppId,
  method: httpMethod.delete,
  url: `/API/auth/v1/apps/${encodeURIComponent(appId)}/`,
  params: { appId },
  headers,
});

/**
 * `GET /v1/apps/{app_id}/`
 *
 * Returns a particular app by id
 *
 * Required roles:
 *  - can_read_apps
 *
 * Responses
 * - 200 - Returns a app
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthAppSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_apps__app_id__}
 */
export const httpGetAppsByAppId = (
  appId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAppsByAppId,
  method: httpMethod.get,
  url: `/API/auth/v1/apps/${encodeURIComponent(appId)}/`,
  params: { appId },
  headers,
});

export type AuthAppSchemaPartial = Partial<AuthAppSchema>;

/**
 * `PATCH /v1/apps/{app_id}/`
 *
 * Update app
 *
 * Required roles:
 *  - can_write_apps
 *
 * Responses
 * - 200 - Returns an updated app
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthAppSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_apps__app_id__}
 */
export const httpPatchAppsByAppId = (
  appId: string,
  body: AuthAppSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchAppsByAppId,
  method: httpMethod.patch,
  url: `/API/auth/v1/apps/${encodeURIComponent(appId)}/`,
  params: { appId },
  body,
  headers,
});

/**
 * `PUT /v1/apps/{app_id}/`
 *
 * Update app
 *
 * Required roles:
 *  - can_write_apps
 *
 * Responses
 * - 200 - Returns an updated app
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthAppSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_apps__app_id__}
 */
export const httpPutAppsByAppId = (
  appId: string,
  body: AuthAppSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutAppsByAppId,
  method: httpMethod.put,
  url: `/API/auth/v1/apps/${encodeURIComponent(appId)}/`,
  params: { appId },
  body,
  headers,
});

export interface AuthHttpPostAppsByAppIdTokenQuery {
  /**
   * The number of seconds the token will be valid for. Defaults to the system default.
   */
  expires_in?: number;
}

/**
 * `POST /v1/apps/{app_id}/token/`
 *
 * Creates app token by id and returns it's data
 *
 * Required roles:
 *  - can_read_apps
 *
 * Responses
 * - 200 - Returns an application token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokenSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_apps__app_id__token_}
 */
export const httpPostAppsByAppIdToken = (
  appId: string,
  query?: AuthHttpPostAppsByAppIdTokenQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAppsByAppIdToken,
  method: httpMethod.post,
  url: `/API/auth/v1/apps/${encodeURIComponent(appId)}/token/`,
  params: { appId },
  query,
  headers,
});

/**
 * `POST /v1/auth/ad/login/`
 *
 * Login by ActiveDirectory
 *
 * <br/>This function is not yet implemented.
 *
 * Responses
 * - 201 - Returns a new generated token for particular user
 * - 400 - Bad request
 *
 * Response {@link AuthTokenSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_ad_login_}
 */
export const httpPostAuthAdLogin = (
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthAdLogin,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/ad/login/',

  body,
  headers,
});

/**
 * `POST /v1/auth/current/otp/generate/`
 *
 * Request OTP code as an authenticated user
 *
 *
 * Responses
 * - 201 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_current_otp_generate_}
 */
export const httpPostAuthCurrentOtpGenerate = (headers?: IconikApiHeaders) => ({
  id: AuthHttpPostAuthCurrentOtpGenerate,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/current/otp/generate/',

  headers,
});

/**
 * `POST /v1/auth/embed/token/`
 *
 * Create a short lived, single use embed token for the logged in user
 *
 *
 * Responses
 * - 201 - Returns an embed token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthEmbedTokenResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_embed_token_}
 */
export const httpPostAuthEmbedToken = (
  body: AuthEmbedTokenRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthEmbedToken,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/embed/token/',

  body,
  headers,
});

export interface AuthHttpPostAuthEmbedTokenExchangeQuery {
  /**
   * Output format, one of `cuttingroom` (default) or `iconik`
   */
  format?: string;
}

/**
 * `POST /v1/auth/embed/token/exchange/`
 *
 * Exchange an embed token for an iconik access token
 *
 *
 * Responses
 * - 200 - Returns an access token and a refresh token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthCuttingRoomTokenResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_embed_token_exchange_}
 */
export const httpPostAuthEmbedTokenExchange = (
  body: AuthTokenExchangeRequestSchema,
  query?: AuthHttpPostAuthEmbedTokenExchangeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthEmbedTokenExchange,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/embed/token/exchange/',

  body,
  query,
  headers,
});

export interface AuthHttpPostAuthMultidomainLoginHeader
  extends IconikApiHeaders {
  'Temp-Auth-Token': string;
}

/**
 * `POST /v1/auth/multidomain/login/`
 *
 * Login by using temp token
 *
 *
 * Responses
 * - 201 - Returns a new generated token for particular user
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokenSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_multidomain_login_}
 */
export const httpPostAuthMultidomainLogin = (
  body: AuthMultiDomainLoginSchema,
  headers: AuthHttpPostAuthMultidomainLoginHeader,
) => ({
  id: AuthHttpPostAuthMultidomainLogin,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/multidomain/login/',

  body,
  headers,
});

export interface AuthHttpPostAuthOtpGenerateHeader extends IconikApiHeaders {
  'Temp-Auth-Token': string;
}

/**
 * `POST /v1/auth/otp/generate/`
 *
 * Request OTP code
 *
 *
 * Responses
 * - 201 - Success
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_otp_generate_}
 */
export const httpPostAuthOtpGenerate = (
  body: AuthMultiDomainLoginSchema,
  headers: AuthHttpPostAuthOtpGenerateHeader,
) => ({
  id: AuthHttpPostAuthOtpGenerate,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/otp/generate/',

  body,
  headers,
});

/**
 * `POST /v1/auth/saml/acs/{public_id}/`
 *
 * SAML Assertion Consumer Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SSO
 * - 400 - Bad request
 * - 401 - Unauthorized request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_acs__public_id__}
 */
export const httpPostAuthSamlAcsByPublicId = (
  publicId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlAcsByPublicId,
  method: httpMethod.post,
  url: `/API/auth/v1/auth/saml/acs/${encodeURIComponent(publicId)}/`,
  params: { publicId },
  headers,
});

/**
 * `POST /v1/auth/saml/acs/{system_domain_id}/{identity_provider_id}/`
 *
 * SAML Assertion Consumer Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SSO
 * - 400 - Bad request
 * - 401 - Unauthorized request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_acs__system_domain_id___identity_provider_id__}
 * @deprecated
 */
export const httpPostAuthSamlAcsBySystemDomainIdByIdentityProviderId = (
  systemDomainId: string,
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlAcsBySystemDomainIdByIdentityProviderId,
  method: httpMethod.post,
  url: `/API/auth/v1/auth/saml/acs/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(identityProviderId)}/`,
  params: { systemDomainId, identityProviderId },
  headers,
});

/**
 * `POST /v1/auth/saml/domains/`
 *
 * Bind domain to identity provider
 *
 *
 * Responses
 * - 201 - Returns an identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthDomainIdentityProviderMapSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_domains_}
 */
export const httpPostAuthSamlDomains = (
  body: AuthDomainIdentityProviderMapSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlDomains,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/saml/domains/',

  body,
  headers,
});

/**
 * `DELETE /v1/auth/saml/domains/{domain}/`
 *
 * Unbind domain from identity provider
 *
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_auth_saml_domains__domain__}
 */
export const httpDeleteAuthSamlDomainsByDomain = (
  domain: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteAuthSamlDomainsByDomain,
  method: httpMethod.delete,
  url: `/API/auth/v1/auth/saml/domains/${encodeURIComponent(domain)}/`,
  params: { domain },
  headers,
});

export interface AuthHttpGetAuthSamlIdpQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
}

/**
 * `GET /v1/auth/saml/idp/`
 *
 * Get list of identity providers
 *
 * Required roles:
 *  - can_read_identity_providers
 *
 * Responses
 * - 200 - Returns a list of identity providers
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link AuthIdentityProvidersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_idp_}
 */
export const httpGetAuthSamlIdp = (
  query?: AuthHttpGetAuthSamlIdpQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlIdp,
  method: httpMethod.get,
  url: '/API/auth/v1/auth/saml/idp/',

  query,
  headers,
});

/**
 * `POST /v1/auth/saml/idp/`
 *
 * Create a new identity provider.
 *
 * <br/>Input can either be an IdentityProviderSchema as json or a SAML<br/>EntityDescriptor XML.<br/>Input can either be an IdentityProviderSchema as json or a SAML<br/>EntityDescriptor XML.
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 201 - Returns an identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthIdentityProviderSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_idp_}
 */
export const httpPostAuthSamlIdp = (
  body: AuthIdentityProviderSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlIdp,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/saml/idp/',

  body,
  headers,
});

/**
 * `POST /v1/auth/saml/idp/convert/`
 *
 * Convert an IdP EntityDescriptor XML into json suitable as a settings configuration.
 *
 * <br/>Input should be a SAML EntityDescriptor XML.
 *
 * Responses
 * - 201 - Returns an identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthIdentityProviderSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_idp_convert_}
 */
export const httpPostAuthSamlIdpConvert = (
  body: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlIdpConvert,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/saml/idp/convert/',

  body,
  headers,
});

/**
 * `DELETE /v1/auth/saml/idp/{identity_provider_id}/`
 *
 * Delete a particular identity provider by id
 *
 * Required roles:
 *  - can_delete_identity_providers
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Identity provider does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_auth_saml_idp__identity_provider_id__}
 */
export const httpDeleteAuthSamlIdpByIdentityProviderId = (
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteAuthSamlIdpByIdentityProviderId,
  method: httpMethod.delete,
  url: `/API/auth/v1/auth/saml/idp/${encodeURIComponent(identityProviderId)}/`,
  params: { identityProviderId },
  headers,
});

/**
 * `GET /v1/auth/saml/idp/{identity_provider_id}/`
 *
 * Get a particular identity provider by id
 *
 * Required roles:
 *  - can_read_identity_providers
 *
 * Responses
 * - 200 - Returns an identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Identity provider does not exist
 *
 * Response {@link AuthIdentityProviderSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_idp__identity_provider_id__}
 */
export const httpGetAuthSamlIdpByIdentityProviderId = (
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlIdpByIdentityProviderId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/idp/${encodeURIComponent(identityProviderId)}/`,
  params: { identityProviderId },
  headers,
});

export type AuthIdentityProviderSchemaPartial =
  Partial<AuthIdentityProviderSchema>;

/**
 * `PATCH /v1/auth/saml/idp/{identity_provider_id}/`
 *
 * Update a particular identity provider by id
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 200 - Returns an updated identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Identity provider does not exist
 *
 * Response {@link AuthIdentityProviderSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_auth_saml_idp__identity_provider_id__}
 */
export const httpPatchAuthSamlIdpByIdentityProviderId = (
  identityProviderId: string,
  body: AuthIdentityProviderSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchAuthSamlIdpByIdentityProviderId,
  method: httpMethod.patch,
  url: `/API/auth/v1/auth/saml/idp/${encodeURIComponent(identityProviderId)}/`,
  params: { identityProviderId },
  body,
  headers,
});

/**
 * `PUT /v1/auth/saml/idp/{identity_provider_id}/`
 *
 * Update a particular identity provider by id
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 200 - Returns an updated identity provider
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Identity provider does not exist
 *
 * Response {@link AuthIdentityProviderSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_auth_saml_idp__identity_provider_id__}
 */
export const httpPutAuthSamlIdpByIdentityProviderId = (
  identityProviderId: string,
  body: AuthIdentityProviderSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutAuthSamlIdpByIdentityProviderId,
  method: httpMethod.put,
  url: `/API/auth/v1/auth/saml/idp/${encodeURIComponent(identityProviderId)}/`,
  params: { identityProviderId },
  body,
  headers,
});

/**
 * Returns an saml sso url
 */
export interface AuthHttpPostAuthSamlLoginResponse {
  /**
   * saml sso url
   */
  url?: string;
}

/**
 * `POST /v1/auth/saml/login/`
 *
 * SAML Single sign-on url by domain
 *
 *
 * Responses
 * - 200 - Returns an saml sso url
 * - 404 - Requested page does not exist
 *
 * Response {@link AuthHttpPostAuthSamlLoginResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_login_}
 * @deprecated
 */
export const httpPostAuthSamlLogin = (
  body: AuthSAMLLoginSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlLogin,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/saml/login/',

  body,
  headers,
});

/**
 * Returns an saml slo url
 */
export interface AuthHttpPostAuthSamlLogoutByPublicIdResponse {
  /**
   * saml sso url. No url is returned if Single Logout is unsupported by IdP
   */
  url?: string;
}

/**
 * `POST /v1/auth/saml/logout/{public_id}/`
 *
 * Initiate SAML Single logout
 *
 *
 * Responses
 * - 200 - Returns an saml slo url
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthHttpPostAuthSamlLogoutByPublicIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_logout__public_id__}
 */
export const httpPostAuthSamlLogoutByPublicId = (
  publicId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlLogoutByPublicId,
  method: httpMethod.post,
  url: `/API/auth/v1/auth/saml/logout/${encodeURIComponent(publicId)}/`,
  params: { publicId },
  headers,
});

/**
 * `GET /v1/auth/saml/metadata/{public_id}/`
 *
 * SAML Single Logout Service
 *
 *
 * Responses
 * - 200 - Return SAML SP metadata
 * - 400 - Bad request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_metadata__public_id__}
 */
export const httpGetAuthSamlMetadataByPublicId = (
  publicId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlMetadataByPublicId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/metadata/${encodeURIComponent(publicId)}/`,
  params: { publicId },
  headers,
});

/**
 * `GET /v1/auth/saml/metadata/{system_domain_id}/{identity_provider_id}/`
 *
 * SAML Single Logout Service
 *
 *
 * Responses
 * - 200 - Return SAML SP metadata
 * - 400 - Bad request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_metadata__system_domain_id___identity_provider_id__}
 * @deprecated
 */
export const httpGetAuthSamlMetadataBySystemDomainIdByIdentityProviderId = (
  systemDomainId: string,
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlMetadataBySystemDomainIdByIdentityProviderId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/metadata/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(identityProviderId)}/`,
  params: { systemDomainId, identityProviderId },
  headers,
});

/**
 * `POST /v1/auth/saml/multidomain/login/`
 *
 * SAML Single sign-on url by domain
 *
 *
 * Responses
 * - 200 - Returns list of SSO domains
 * - 404 - Requested page does not exist
 *
 * Response {@link AuthMultiDomainUserSystemsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_saml_multidomain_login_}
 */
export const httpPostAuthSamlMultidomainLogin = (
  body: AuthSAMLLoginSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSamlMultidomainLogin,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/saml/multidomain/login/',

  body,
  headers,
});

/**
 * `GET /v1/auth/saml/slo/{public_id}/`
 *
 * SAML Single Logout Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SLO
 * - 400 - Bad request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_slo__public_id__}
 */
export const httpGetAuthSamlSloByPublicId = (
  publicId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlSloByPublicId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/slo/${encodeURIComponent(publicId)}/`,
  params: { publicId },
  headers,
});

/**
 * `GET /v1/auth/saml/slo/{system_domain_id}/{identity_provider_id}/`
 *
 * SAML Single Logout Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SLO
 * - 400 - Bad request
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_slo__system_domain_id___identity_provider_id__}
 * @deprecated
 */
export const httpGetAuthSamlSloBySystemDomainIdByIdentityProviderId = (
  systemDomainId: string,
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlSloBySystemDomainIdByIdentityProviderId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/slo/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(identityProviderId)}/`,
  params: { systemDomainId, identityProviderId },
  headers,
});

/**
 * `GET /v1/auth/saml/sso/{public_id}/`
 *
 * SAML Single sign-on Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SSO
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_sso__public_id__}
 */
export const httpGetAuthSamlSsoByPublicId = (
  publicId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlSsoByPublicId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/sso/${encodeURIComponent(publicId)}/`,
  params: { publicId },
  headers,
});

/**
 * `GET /v1/auth/saml/sso/{system_domain_id}/{identity_provider_id}/`
 *
 * SAML Single sign-on Service
 *
 *
 * Responses
 * - 302 - Redirect on SAML IDP for SSO
 * - 404 - Requested page does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_saml_sso__system_domain_id___identity_provider_id__}
 * @deprecated
 */
export const httpGetAuthSamlSsoBySystemDomainIdByIdentityProviderId = (
  systemDomainId: string,
  identityProviderId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthSamlSsoBySystemDomainIdByIdentityProviderId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/saml/sso/${encodeURIComponent(systemDomainId)}/${encodeURIComponent(identityProviderId)}/`,
  params: { systemDomainId, identityProviderId },
  headers,
});

/**
 * `POST /v1/auth/simple/login/`
 *
 * Login by using email and password
 *
 *
 * Responses
 * - 201 - Returns a new generated token for particular user
 * - 400 - Bad request
 *
 * Response {@link AuthTokenMultiplatformLoginSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_simple_login_}
 */
export const httpPostAuthSimpleLogin = (
  body: AuthSimpleLoginSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthSimpleLogin,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/simple/login/',

  body,
  headers,
});

/**
 * `DELETE /v1/auth/token/`
 *
 * Revoke token
 *
 *
 * Responses
 * - 200 - Returns if token was revoked
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_auth_token_}
 */
export const httpDeleteAuthToken = (headers?: IconikApiHeaders) => ({
  id: AuthHttpDeleteAuthToken,
  method: httpMethod.delete,
  url: '/API/auth/v1/auth/token/',

  headers,
});

/**
 * `GET /v1/auth/token/`
 *
 * Check if auth token valid
 *
 *
 * Responses
 * - 200 - Returns if token valid
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_token_}
 */
export const httpGetAuthToken = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetAuthToken,
  method: httpMethod.get,
  url: '/API/auth/v1/auth/token/',

  headers,
});

export interface AuthHttpPostAuthTokenQuery {
  /**
   * The number of seconds the token will be valid for. Defaults to the system default.
   */
  expires_in?: number;
}

/**
 * `POST /v1/auth/token/`
 *
 * Create new token without invalidating the old one
 *
 *
 * Responses
 * - 201 - Returns a new token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokenSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_auth_token_}
 */
export const httpPostAuthToken = (
  query?: AuthHttpPostAuthTokenQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostAuthToken,
  method: httpMethod.post,
  url: '/API/auth/v1/auth/token/',

  query,
  headers,
});

/**
 * `PUT /v1/auth/token/`
 *
 * Refresh token
 *
 *
 * Responses
 * - 200 - Returns a new token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_auth_token_}
 */
export const httpPutAuthToken = (headers?: IconikApiHeaders) => ({
  id: AuthHttpPutAuthToken,
  method: httpMethod.put,
  url: '/API/auth/v1/auth/token/',

  headers,
});

/**
 * `DELETE /v1/auth/token/{token_id}/`
 *
 * Revoke token by ID
 *
 *
 * Responses
 * - 200 - Returns if token was revoked
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_auth_token__token_id__}
 */
export const httpDeleteAuthTokenByTokenId = (
  tokenId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteAuthTokenByTokenId,
  method: httpMethod.delete,
  url: `/API/auth/v1/auth/token/${encodeURIComponent(tokenId)}/`,
  params: { tokenId },
  headers,
});

/**
 * `GET /v1/auth/token/{token_id}/`
 *
 * Get token by ID
 *
 *
 * Responses
 * - 200 - Returns a token
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_token__token_id__}
 */
export const httpGetAuthTokenByTokenId = (
  tokenId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthTokenByTokenId,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/token/${encodeURIComponent(tokenId)}/`,
  params: { tokenId },
  headers,
});

export interface AuthHttpGetAuthTokensQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/auth/tokens/`
 *
 * List of tokens
 *
 *
 * Responses
 * - 200 - Returns a list of tokens
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokensSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth_tokens_}
 */
export const httpGetAuthTokens = (
  query?: AuthHttpGetAuthTokensQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthTokens,
  method: httpMethod.get,
  url: '/API/auth/v1/auth/tokens/',

  query,
  headers,
});

export interface AuthHttpGetAuthByAppIdTokensQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of a last file set on previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/auth/{app_id}/tokens/`
 *
 * List application tokens
 *
 *
 * Responses
 * - 200 - Returns a list of tokens
 * - 401 - Token is invalid
 *
 * Response {@link AuthTokensSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_auth__app_id__tokens_}
 */
export const httpGetAuthByAppIdTokens = (
  appId: string,
  query?: AuthHttpGetAuthByAppIdTokensQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetAuthByAppIdTokens,
  method: httpMethod.get,
  url: `/API/auth/v1/auth/${encodeURIComponent(appId)}/tokens/`,
  params: { appId },
  query,
  headers,
});

/**
 * `PUT /v1/invitation/complete/{reset_hash}/`
 *
 * Completes invitation by setting password and other user details
 *
 *
 * Responses
 * - 200 - User completed invite process
 * - 400 - Bad request
 * - 419 - Authentication token expired
 *
 * Response {@link AuthInvitationResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_invitation_complete__reset_hash__}
 */
export const httpPutInvitationCompleteByResetHash = (
  resetHash: string,
  body: AuthCompleteInvitationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutInvitationCompleteByResetHash,
  method: httpMethod.put,
  url: `/API/auth/v1/invitation/complete/${encodeURIComponent(resetHash)}/`,
  params: { resetHash },
  body,
  headers,
});

/**
 * `POST /v1/marketplace/google/link/`
 *
 * Google cloud marketplace link to existing system domain
 *
 *
 * Responses
 * - 200 - Successfully linked google account to existing system domain
 * - 400 - Bad request
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_marketplace_google_link_}
 */
export const httpPostMarketplaceGoogleLink = (
  body: AuthMarketplaceGoogleLinkSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostMarketplaceGoogleLink,
  method: httpMethod.post,
  url: '/API/auth/v1/marketplace/google/link/',

  body,
  headers,
});

/**
 * `POST /v1/marketplace/google/signup/`
 *
 * Google cloud marketplace signup
 *
 *
 * Responses
 * - 302 - Redirects to the registration page
 * - 400 - Bad request
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_marketplace_google_signup_}
 */
export const httpPostMarketplaceGoogleSignup = (
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostMarketplaceGoogleSignup,
  method: httpMethod.post,
  url: '/API/auth/v1/marketplace/google/signup/',

  body,
  headers,
});

export interface AuthHttpGetOauthAuthorizeQuery {
  /**
   * The OAuth2 application client ID
   */
  client_id: string;
  /**
   * The URI to redirect to after authorization. Must exactly match one of the URIs registered for the application.
   */
  redirect_uri: string;
  /**
   * Space-separated list of scopes to request (e.g. "assets:read assets:write"). The returned `scopes` field is filtered down to the intersection of the requested scopes and the application's allowed scopes - it may be empty if none overlap. This endpoint never rejects a request just because it asked for scopes the application isn't allowed to have; every requested scope must still be one this platform supports, though.
   */
  scope: string;
  /**
   * Must be "code" for the Authorization Code flow.
   */
  response_type: string;
  /**
   * PKCE code challenge — the Base64url-encoded SHA-256 hash of the code_verifier. Required for all authorization requests.
   */
  code_challenge: string;
  /**
   * The method used to derive the code_challenge. Only "S256" is supported; defaults to "S256" if omitted.
   */
  code_challenge_method?: string;
}

/**
 * `GET /v1/oauth/authorize/`
 *
 * Validate the authorization request and return consent metadata
 *
 * (client name, authorizing user, system domain, scopes, redirect_uri,<br/>state). No code is minted.
 *
 * Responses
 * - 200 - Consent metadata (client name, authorizing user, system domain, scopes, redirect_uri, state).
 * - 400 - Bad request (invalid client_id, redirect_uri, scope, etc.)
 *
 * Response {@link AuthOAuth2AuthorizeDescribeSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_oauth_authorize_}
 */
export const httpGetOauthAuthorize = (
  query?: AuthHttpGetOauthAuthorizeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetOauthAuthorize,
  method: httpMethod.get,
  url: '/API/auth/v1/oauth/authorize/',

  query,
  headers,
});

export interface AuthHttpPostOauthAuthorizeQuery {
  /**
   * The OAuth2 application client ID
   */
  client_id: string;
  /**
   * The URI to redirect to after authorization. Must exactly match one of the URIs registered for the application.
   */
  redirect_uri: string;
  /**
   * Space-separated list of scopes to request (e.g. "assets:read assets:write"). Unlike the GET describe step, this endpoint requires every requested scope to be within the application's allowed scopes and rejects the whole request otherwise (no partial grants), since this is the step that actually mints the authorization code. Every requested scope must also be one this platform supports.
   */
  scope: string;
  /**
   * Must be "code" for the Authorization Code flow.
   */
  response_type: string;
  /**
   * PKCE code challenge — the Base64url-encoded SHA-256 hash of the code_verifier. Required for all authorization requests.
   */
  code_challenge: string;
  /**
   * The method used to derive the code_challenge. Only "S256" is supported; defaults to "S256" if omitted.
   */
  code_challenge_method?: string;
}

/**
 * `POST /v1/oauth/authorize/`
 *
 * Submit the user's consent decision. If ``confirm`` is present in
 *
 * the form body the authorization code is minted; otherwise the<br/>request is denied (``error=access_denied``).
 *
 * Responses
 * - 200 - Redirect URI containing the authorization code.
 * - 400 - Bad request (invalid client_id, redirect_uri, scope, etc.)
 *
 * Response {@link AuthOAuth2AuthorizeResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_oauth_authorize_}
 */
export const httpPostOauthAuthorize = (
  query?: AuthHttpPostOauthAuthorizeQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostOauthAuthorize,
  method: httpMethod.post,
  url: '/API/auth/v1/oauth/authorize/',

  query,
  headers,
});

export interface AuthHttpPostOauthTokenQuery {
  /**
   * The number of seconds the access token will be valid for. Defaults to, and is clamped by, the system default.
   */
  expires_in?: number;
}

export interface AuthHttpPostOauthTokenHeader extends IconikApiHeaders {
  /**
   * HTTP Basic credentials for a confidential client (``client_secret_basic``), as an alternative to sending client_id / client_secret in the form body.
   */
  Authorization?: string;
}

/**
 * `POST /v1/oauth/token/`
 *
 * Issue an OAuth token
 *
 *
 * Responses
 * - 200 - Returns a new generated token for particular user
 * - 400 - Bad request
 *
 * Response {@link AuthTokenSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_oauth_token_}
 */
export const httpPostOauthToken = (
  body: object,
  query?: AuthHttpPostOauthTokenQuery,
  headers?: AuthHttpPostOauthTokenHeader,
) => ({
  id: AuthHttpPostOauthToken,
  method: httpMethod.post,
  url: '/API/auth/v1/oauth/token/',

  body,
  query,
  headers,
});

/**
 * `GET /v1/password/checks/`
 *
 * Returns a list of password checks required for the password to be safe
 *
 *
 * Responses
 * - 200 - Password checks
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthPasswordChecksSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_password_checks_}
 */
export const httpGetPasswordChecks = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetPasswordChecks,
  method: httpMethod.get,
  url: '/API/auth/v1/password/checks/',

  headers,
});

/**
 * `POST /v1/password/forgot/`
 *
 * Receives email address and sends email to this address with a link for resetting password.
 *
 *
 * Responses
 * - 201 - Reset password email was sent to an email
 * - 400 - Bad request
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_password_forgot_}
 */
export const httpPostPasswordForgot = (
  body: AuthForgotPasswordSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostPasswordForgot,
  method: httpMethod.post,
  url: '/API/auth/v1/password/forgot/',

  body,
  headers,
});

/**
 * `PUT /v1/password/reset/{reset_hash}/`
 *
 * Changes password to a new one
 *
 *
 * Responses
 * - 200 - Password was changed
 * - 400 - Bad request
 * - 419 - Authentication token expired
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_password_reset__reset_hash__}
 */
export const httpPutPasswordResetByResetHash = (
  resetHash: string,
  body: AuthResetPasswordSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutPasswordResetByResetHash,
  method: httpMethod.put,
  url: `/API/auth/v1/password/reset/${encodeURIComponent(resetHash)}/`,
  params: { resetHash },
  body,
  headers,
});

/**
 * `GET /v1/password/{reset_hash}/checks/`
 *
 * Returns a list of password checks required for the password to be safe
 *
 *
 * Responses
 * - 200 - Password checks
 * - 400 - Bad request
 * - 419 - Reset password token expired
 *
 * Response {@link AuthPasswordChecksSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_password__reset_hash__checks_}
 */
export const httpGetPasswordByResetHashChecks = (
  resetHash: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetPasswordByResetHashChecks,
  method: httpMethod.get,
  url: `/API/auth/v1/password/${encodeURIComponent(resetHash)}/checks/`,
  params: { resetHash },
  headers,
});

/**
 * `GET /v1/referral_codes/`
 *
 * Get all referral_codes
 *
 *
 * Responses
 * - 200 - Returns a referral_code
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthReferralCodesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_referral_codes_}
 */
export const httpGetReferralCodes = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetReferralCodes,
  method: httpMethod.get,
  url: '/API/auth/v1/referral_codes/',

  headers,
});

/**
 * `POST /v1/referral_codes/`
 *
 * Create a new referral_code
 *
 *
 * Responses
 * - 201 - Returns a created referral_code
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 409 - Code already exists
 *
 * Response {@link AuthReferralCodeSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_referral_codes_}
 */
export const httpPostReferralCodes = (
  body: AuthReferralCodeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostReferralCodes,
  method: httpMethod.post,
  url: '/API/auth/v1/referral_codes/',

  body,
  headers,
});

/**
 * `DELETE /v1/referral_codes/{code}/`
 *
 * Delete a referral_code
 *
 *
 * Responses
 * - 204 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_referral_codes__code__}
 */
export const httpDeleteReferralCodesByCode = (
  code: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteReferralCodesByCode,
  method: httpMethod.delete,
  url: `/API/auth/v1/referral_codes/${encodeURIComponent(code)}/`,
  params: { code },
  headers,
});

/**
 * `GET /v1/referral_codes/{code}/`
 *
 * Get a referral_code
 *
 *
 * Responses
 * - 200 - Returns a referral_code
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthReferralCodeSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_referral_codes__code__}
 */
export const httpGetReferralCodesByCode = (
  code: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetReferralCodesByCode,
  method: httpMethod.get,
  url: `/API/auth/v1/referral_codes/${encodeURIComponent(code)}/`,
  params: { code },
  headers,
});

/**
 * `POST /v1/registrations/`
 *
 * Create a new registration
 *
 *
 * Responses
 * - 201 - Returns a created registration
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthRegistrationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_registrations_}
 */
export const httpPostRegistrations = (
  body: AuthRegistrationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostRegistrations,
  method: httpMethod.post,
  url: '/API/auth/v1/registrations/',

  body,
  headers,
});

export interface AuthHttpGetRegistrationsContentQuery {
  /**
   * Page route to fetch content for
   */
  page_route: string;
}

/**
 * `GET /v1/registrations/content/`
 *
 * Returns page content from Webflow collection
 *
 *
 * Responses
 * - 200 - Returns page content from Webflow collection
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthWebflowContentSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_registrations_content_}
 */
export const httpGetRegistrationsContent = (
  query?: AuthHttpGetRegistrationsContentQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetRegistrationsContent,
  method: httpMethod.get,
  url: '/API/auth/v1/registrations/content/',

  query,
  headers,
});

/**
 * `GET /v1/registrations/countries/`
 *
 * Returns list of countries
 *
 *
 * Responses
 * - 200 - Returns a list of countries
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthCountriesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_registrations_countries_}
 */
export const httpGetRegistrationsCountries = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetRegistrationsCountries,
  method: httpMethod.get,
  url: '/API/auth/v1/registrations/countries/',

  headers,
});

/**
 * `POST /v1/registrations/verify/{email_hash}/`
 *
 * Verify email address, create system domain from template, and authenticate user
 *
 *
 * Responses
 * - 201 - Returns a created system domain and login data if auto-login
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthVerificationResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_registrations_verify__email_hash__}
 */
export const httpPostRegistrationsVerifyByEmailHash = (
  emailHash: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostRegistrationsVerifyByEmailHash,
  method: httpMethod.post,
  url: `/API/auth/v1/registrations/verify/${encodeURIComponent(emailHash)}/`,
  params: { emailHash },
  headers,
});

export interface AuthHttpGetScimConfigQuery {
  /**
   * Only the config paired with this SAML identity provider
   */
  identity_provider_id?: string;
}

/**
 * `GET /v1/scim/config/`
 *
 * List SCIM provisioning configs
 *
 * Required roles:
 *  - can_read_identity_providers
 *
 * Responses
 * - 200 - SCIM configs
 * - 400 - identity_provider_id is not a valid id
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 *
 * Response {@link AuthSCIMConfigListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_config_}
 */
export const httpGetScimConfig = (
  query?: AuthHttpGetScimConfigQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimConfig,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/config/',

  query,
  headers,
});

/**
 * `POST /v1/scim/config/`
 *
 * Create a SCIM provisioning config
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 201 - Created SCIM config
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 *
 * Response {@link AuthSCIMConfigSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_scim_config_}
 */
export const httpPostScimConfig = (
  body: AuthSCIMConfigSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostScimConfig,
  method: httpMethod.post,
  url: '/API/auth/v1/scim/config/',

  body,
  headers,
});

/**
 * `DELETE /v1/scim/config/{config_id}/`
 *
 * Delete a SCIM provisioning config (revokes its token)
 *
 * Required roles:
 *  - can_delete_identity_providers
 *
 * Responses
 * - 204 - Deleted
 * - 401 - Token is invalid
 * - 404 - SCIM config not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_scim_config__config_id__}
 */
export const httpDeleteScimConfigByConfigId = (
  configId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteScimConfigByConfigId,
  method: httpMethod.delete,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/`,
  params: { configId },
  headers,
});

/**
 * `GET /v1/scim/config/{config_id}/`
 *
 * Get a SCIM provisioning config
 *
 * Required roles:
 *  - can_read_identity_providers
 *
 * Responses
 * - 200 - SCIM config
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMConfigSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_config__config_id__}
 */
export const httpGetScimConfigByConfigId = (
  configId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimConfigByConfigId,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/`,
  params: { configId },
  headers,
});

export type AuthSCIMConfigSchemaPartial = Partial<AuthSCIMConfigSchema>;

/**
 * `PATCH /v1/scim/config/{config_id}/`
 *
 * Update a SCIM provisioning config
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 200 - Updated SCIM config
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMConfigSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_scim_config__config_id__}
 */
export const httpPatchScimConfigByConfigId = (
  configId: string,
  body: AuthSCIMConfigSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchScimConfigByConfigId,
  method: httpMethod.patch,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/`,
  params: { configId },
  body,
  headers,
});

/**
 * `PUT /v1/scim/config/{config_id}/`
 *
 * Update a SCIM provisioning config
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 200 - Updated SCIM config
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMConfigSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_scim_config__config_id__}
 */
export const httpPutScimConfigByConfigId = (
  configId: string,
  body: AuthSCIMConfigSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutScimConfigByConfigId,
  method: httpMethod.put,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/`,
  params: { configId },
  body,
  headers,
});

/**
 * `GET /v1/scim/config/{config_id}/groups/`
 *
 * List the iconik groups managed by a SCIM config
 *
 * Required roles:
 *  - can_read_identity_providers
 *
 * Responses
 * - 200 - Groups managed by the SCIM config
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMManagedGroupListSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_config__config_id__groups_}
 */
export const httpGetScimConfigByConfigIdGroups = (
  configId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimConfigByConfigIdGroups,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/groups/`,
  params: { configId },
  headers,
});

/**
 * `PUT /v1/scim/config/{config_id}/groups/`
 *
 * Mark existing iconik groups as managed by a SCIM config
 *
 * <br/>Once marked, the IdP controls the group's name and membership, and the<br/>group stops being treated as a SAML group. The Everyone group and groups<br/>managed by another SCIM config are refused.<br/>Once marked, the IdP controls the group's name and membership, and the<br/>group stops being treated as a SAML group. The Everyone group and groups<br/>managed by another SCIM config are refused.
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 200 - The marked group ids, and why any others were refused
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMMarkGroupsResponseSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_scim_config__config_id__groups_}
 */
export const httpPutScimConfigByConfigIdGroups = (
  configId: string,
  body: AuthSCIMMarkGroupsRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutScimConfigByConfigIdGroups,
  method: httpMethod.put,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/groups/`,
  params: { configId },
  body,
  headers,
});

/**
 * `DELETE /v1/scim/config/{config_id}/groups/{group_id}/`
 *
 * Stop a SCIM config from managing a group (the group is kept)
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 204 - Released
 * - 401 - Token is invalid
 * - 404 - SCIM config not found, or the group isn't managed by it
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_scim_config__config_id__groups__group_id__}
 */
export const httpDeleteScimConfigByConfigIdGroupsByGroupId = (
  configId: string,
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteScimConfigByConfigIdGroupsByGroupId,
  method: httpMethod.delete,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/groups/${encodeURIComponent(groupId)}/`,
  params: { configId, groupId },
  headers,
});

/**
 * `DELETE /v1/scim/config/{config_id}/token/`
 *
 * Revoke the SCIM bearer token
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 204 - Revoked
 * - 401 - Token is invalid
 * - 404 - SCIM config not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_scim_config__config_id__token_}
 */
export const httpDeleteScimConfigByConfigIdToken = (
  configId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteScimConfigByConfigIdToken,
  method: httpMethod.delete,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/token/`,
  params: { configId },
  headers,
});

/**
 * `POST /v1/scim/config/{config_id}/token/`
 *
 * Generate (or rotate) the SCIM bearer token. The token is returned only once
 *
 * Required roles:
 *  - can_write_identity_providers
 *
 * Responses
 * - 201 - New SCIM token
 * - 400 - Invalid expires_in_days (1-3650)
 * - 401 - Token is invalid
 * - 403 - SCIM provisioning is not enabled for this system domain
 * - 404 - SCIM config not found
 *
 * Response {@link AuthSCIMTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_scim_config__config_id__token_}
 */
export const httpPostScimConfigByConfigIdToken = (
  configId: string,
  body: AuthSCIMTokenRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostScimConfigByConfigIdToken,
  method: httpMethod.post,
  url: `/API/auth/v1/scim/config/${encodeURIComponent(configId)}/token/`,
  params: { configId },
  body,
  headers,
});

/**
 * SCIM ListResponse of Groups
 */
export interface AuthHttpGetScimV2GroupsResponse {}

export interface AuthHttpGetScimV2GroupsQuery {
  /**
   * Supports `displayName`, `externalId` or `id` `eq "..."` (other filters are a 400)
   */
  filter?: string;
  startIndex?: number;
  count?: number;
  /**
   * Pass `members` to omit group members from the response
   */
  excludedAttributes?: string;
}

/**
 * `GET /v1/scim/v2/Groups/`
 *
 * List or filter SCIM Groups
 *
 *
 * Responses
 * - 200 - SCIM ListResponse of Groups
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 *
 * Response {@link AuthHttpGetScimV2GroupsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_groups_}
 */
export const httpGetScimV2Groups = (
  query?: AuthHttpGetScimV2GroupsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2Groups,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/v2/Groups/',

  query,
  headers,
});

/**
 * Created SCIM Group
 */
export interface AuthHttpPostScimV2GroupsResponse {}

/**
 * `POST /v1/scim/v2/Groups/`
 *
 * Create a SCIM Group
 *
 *
 * Responses
 * - 201 - Created SCIM Group
 * - 400 - Invalid SCIM payload
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 409 - Group already exists
 *
 * Response {@link AuthHttpPostScimV2GroupsResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_scim_v2_groups_}
 */
export const httpPostScimV2Groups = (
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostScimV2Groups,
  method: httpMethod.post,
  url: '/API/auth/v1/scim/v2/Groups/',

  body,
  headers,
});

/**
 * `DELETE /v1/scim/v2/Groups/{group_id}/`
 *
 * Delete a SCIM Group
 *
 *
 * Responses
 * - 204 - Group deleted
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - Group not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_scim_v2_groups__group_id__}
 */
export const httpDeleteScimV2GroupsByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteScimV2GroupsByGroupId,
  method: httpMethod.delete,
  url: `/API/auth/v1/scim/v2/Groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

/**
 * SCIM Group resource
 */
export interface AuthHttpGetScimV2GroupsByGroupIdResponse {}

export interface AuthHttpGetScimV2GroupsByGroupIdQuery {
  /**
   * Pass `members` to omit group members from the response
   */
  excludedAttributes?: string;
}

/**
 * `GET /v1/scim/v2/Groups/{group_id}/`
 *
 * Get a SCIM Group
 *
 *
 * Responses
 * - 200 - SCIM Group resource
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - Group not found
 *
 * Response {@link AuthHttpGetScimV2GroupsByGroupIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_groups__group_id__}
 */
export const httpGetScimV2GroupsByGroupId = (
  groupId: string,
  query?: AuthHttpGetScimV2GroupsByGroupIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2GroupsByGroupId,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/v2/Groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  query,
  headers,
});

export type objectPartial = Partial<object>;

/**
 * Updated SCIM Group
 */
export interface AuthHttpPatchScimV2GroupsByGroupIdResponse {}

/**
 * `PATCH /v1/scim/v2/Groups/{group_id}/`
 *
 * Patch a SCIM Group (rename / membership)
 *
 *
 * Responses
 * - 200 - Updated SCIM Group
 * - 400 - Invalid PatchOp
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - Group not found
 *
 * Response {@link AuthHttpPatchScimV2GroupsByGroupIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_scim_v2_groups__group_id__}
 */
export const httpPatchScimV2GroupsByGroupId = (
  groupId: string,
  body: objectPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchScimV2GroupsByGroupId,
  method: httpMethod.patch,
  url: `/API/auth/v1/scim/v2/Groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * Updated SCIM Group
 */
export interface AuthHttpPutScimV2GroupsByGroupIdResponse {}

/**
 * `PUT /v1/scim/v2/Groups/{group_id}/`
 *
 * Replace a SCIM Group (displayName, externalId and the full member list)
 *
 *
 * Responses
 * - 200 - Updated SCIM Group
 * - 400 - Invalid SCIM payload
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - Group not found
 * - 409 - Another group already has this displayName
 *
 * Response {@link AuthHttpPutScimV2GroupsByGroupIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_scim_v2_groups__group_id__}
 */
export const httpPutScimV2GroupsByGroupId = (
  groupId: string,
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutScimV2GroupsByGroupId,
  method: httpMethod.put,
  url: `/API/auth/v1/scim/v2/Groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * SCIM ListResponse of ResourceTypes
 */
export interface AuthHttpGetScimV2ResourceTypesResponse {}

/**
 * `GET /v1/scim/v2/ResourceTypes/`
 *
 * List SCIM ResourceTypes
 *
 *
 * Responses
 * - 200 - SCIM ListResponse of ResourceTypes
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 *
 * Response {@link AuthHttpGetScimV2ResourceTypesResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_resourcetypes_}
 */
export const httpGetScimV2ResourceTypes = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetScimV2ResourceTypes,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/v2/ResourceTypes/',

  headers,
});

/**
 * ResourceType resource
 */
export interface AuthHttpGetScimV2ResourceTypesByResourceResponse {}

/**
 * `GET /v1/scim/v2/ResourceTypes/{resource}/`
 *
 * Get a SCIM ResourceType
 *
 *
 * Responses
 * - 200 - ResourceType resource
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - ResourceType not found
 *
 * Response {@link AuthHttpGetScimV2ResourceTypesByResourceResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_resourcetypes__resource__}
 */
export const httpGetScimV2ResourceTypesByResource = (
  resource: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2ResourceTypesByResource,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/v2/ResourceTypes/${encodeURIComponent(resource)}/`,
  params: { resource },
  headers,
});

/**
 * SCIM ListResponse of Schemas
 */
export interface AuthHttpGetScimV2SchemasResponse {}

/**
 * `GET /v1/scim/v2/Schemas/`
 *
 * List SCIM Schemas
 *
 *
 * Responses
 * - 200 - SCIM ListResponse of Schemas
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 *
 * Response {@link AuthHttpGetScimV2SchemasResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_schemas_}
 */
export const httpGetScimV2Schemas = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetScimV2Schemas,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/v2/Schemas/',

  headers,
});

/**
 * SCIM Schema resource
 */
export interface AuthHttpGetScimV2SchemasBySchemaIdResponse {}

/**
 * `GET /v1/scim/v2/Schemas/{schema_id}/`
 *
 * Get one SCIM schema by its URN (the `meta.location` of a /Schemas entry)
 *
 *
 * Responses
 * - 200 - SCIM Schema resource
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - Schema not found
 *
 * Response {@link AuthHttpGetScimV2SchemasBySchemaIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_schemas__schema_id__}
 */
export const httpGetScimV2SchemasBySchemaId = (
  schemaId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2SchemasBySchemaId,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/v2/Schemas/${encodeURIComponent(schemaId)}/`,
  params: { schemaId },
  headers,
});

/**
 * ServiceProviderConfig resource
 */
export interface AuthHttpGetScimV2ServiceProviderConfigResponse {}

/**
 * `GET /v1/scim/v2/ServiceProviderConfig/`
 *
 * SCIM ServiceProviderConfig (RFC 7643 section 5)
 *
 *
 * Responses
 * - 200 - ServiceProviderConfig resource
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 *
 * Response {@link AuthHttpGetScimV2ServiceProviderConfigResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_serviceproviderconfig_}
 */
export const httpGetScimV2ServiceProviderConfig = (
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2ServiceProviderConfig,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/v2/ServiceProviderConfig/',

  headers,
});

/**
 * SCIM ListResponse of Users
 */
export interface AuthHttpGetScimV2UsersResponse {}

export interface AuthHttpGetScimV2UsersQuery {
  /**
   * Supports `userName`, `externalId` or `id` `eq "..."` (other filters are a 400); omitted lists all users
   */
  filter?: string;
  /**
   * 1-based index of the first result
   */
  startIndex?: number;
  /**
   * Page size (max 100)
   */
  count?: number;
}

/**
 * `GET /v1/scim/v2/Users/`
 *
 * List or filter SCIM Users
 *
 *
 * Responses
 * - 200 - SCIM ListResponse of Users
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 *
 * Response {@link AuthHttpGetScimV2UsersResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_users_}
 */
export const httpGetScimV2Users = (
  query?: AuthHttpGetScimV2UsersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2Users,
  method: httpMethod.get,
  url: '/API/auth/v1/scim/v2/Users/',

  query,
  headers,
});

/**
 * Created SCIM User
 */
export interface AuthHttpPostScimV2UsersResponse {}

/**
 * `POST /v1/scim/v2/Users/`
 *
 * Create a SCIM User (one that already exists, by externalId or userName, is a 409)
 *
 *
 * Responses
 * - 201 - Created SCIM User
 * - 400 - Invalid SCIM payload
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 409 - User already exists
 *
 * Response {@link AuthHttpPostScimV2UsersResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_scim_v2_users_}
 */
export const httpPostScimV2Users = (
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostScimV2Users,
  method: httpMethod.post,
  url: '/API/auth/v1/scim/v2/Users/',

  body,
  headers,
});

/**
 * `DELETE /v1/scim/v2/Users/{user_id}/`
 *
 * Deprovision a SCIM User (deactivates the iconik user)
 *
 *
 * Responses
 * - 204 - User deactivated
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - User not found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_scim_v2_users__user_id__}
 */
export const httpDeleteScimV2UsersByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteScimV2UsersByUserId,
  method: httpMethod.delete,
  url: `/API/auth/v1/scim/v2/Users/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

/**
 * SCIM User resource
 */
export interface AuthHttpGetScimV2UsersByUserIdResponse {}

/**
 * `GET /v1/scim/v2/Users/{user_id}/`
 *
 * Get a SCIM User
 *
 *
 * Responses
 * - 200 - SCIM User resource
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - User not found
 *
 * Response {@link AuthHttpGetScimV2UsersByUserIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_scim_v2_users__user_id__}
 */
export const httpGetScimV2UsersByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetScimV2UsersByUserId,
  method: httpMethod.get,
  url: `/API/auth/v1/scim/v2/Users/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

/**
 * Updated SCIM User
 */
export interface AuthHttpPatchScimV2UsersByUserIdResponse {}

/**
 * `PATCH /v1/scim/v2/Users/{user_id}/`
 *
 * Patch a SCIM User
 *
 *
 * Responses
 * - 200 - Updated SCIM User
 * - 400 - Invalid PatchOp
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - User not found
 *
 * Response {@link AuthHttpPatchScimV2UsersByUserIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_scim_v2_users__user_id__}
 */
export const httpPatchScimV2UsersByUserId = (
  userId: string,
  body: objectPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchScimV2UsersByUserId,
  method: httpMethod.patch,
  url: `/API/auth/v1/scim/v2/Users/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});

/**
 * Updated SCIM User
 */
export interface AuthHttpPutScimV2UsersByUserIdResponse {}

/**
 * `PUT /v1/scim/v2/Users/{user_id}/`
 *
 * Replace a SCIM User (omitted name/externalId are cleared, an omitted active is kept)
 *
 *
 * Responses
 * - 200 - Updated SCIM User
 * - 400 - Invalid SCIM payload
 * - 401 - Missing, invalid or revoked SCIM token
 * - 403 - SCIM provisioning disabled or system domain inactive
 * - 404 - User not found
 *
 * Response {@link AuthHttpPutScimV2UsersByUserIdResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_scim_v2_users__user_id__}
 */
export const httpPutScimV2UsersByUserId = (
  userId: string,
  body: object,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutScimV2UsersByUserId,
  method: httpMethod.put,
  url: `/API/auth/v1/scim/v2/Users/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});

export interface AuthHttpGetSystemDomainsQuery {
  /**
   * Query the name
   */
  query?: string;
  /**
   * Comma separated list of statuses to show
   */
  statuses?: string;
}

/**
 * `GET /v1/system_domains/`
 *
 * List of system domains
 *
 *
 * Responses
 * - 200 - Returns a list of system domains
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_system_domains_}
 * @deprecated
 */
export const httpGetSystemDomains = (
  query?: AuthHttpGetSystemDomainsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetSystemDomains,
  method: httpMethod.get,
  url: '/API/auth/v1/system_domains/',

  query,
  headers,
});

/**
 * `POST /v1/system_domains/`
 *
 * Create a new system domain
 *
 *
 * Responses
 * - 201 - Returns a created system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains_}
 */
export const httpPostSystemDomains = (
  body: AuthSystemDomainSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomains,
  method: httpMethod.post,
  url: '/API/auth/v1/system_domains/',

  body,
  headers,
});

/**
 * `GET /v1/system_domains/basic/{system_domain_id}/`
 *
 * Returns a particular system domain without details
 *
 *
 * Responses
 * - 200 - Returns a system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * Response {@link AuthSystemDomainBasicAdminSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_system_domains_basic__system_domain_id__}
 */
export const httpGetSystemDomainsBasicBySystemDomainId = (
  systemDomainId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetSystemDomainsBasicBySystemDomainId,
  method: httpMethod.get,
  url: `/API/auth/v1/system_domains/basic/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  headers,
});

/**
 * `POST /v1/system_domains/from_template/{template_id}/`
 *
 * Create a new system domain from template
 *
 *
 * Responses
 * - 201 - Returns a created system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainFromTemplateSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains_from_template__template_id__}
 */
export const httpPostSystemDomainsFromTemplateByTemplateId = (
  templateId: string,
  body: AuthSystemDomainFromTemplateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomainsFromTemplateByTemplateId,
  method: httpMethod.post,
  url: `/API/auth/v1/system_domains/from_template/${encodeURIComponent(templateId)}/`,
  params: { templateId },
  body,
  headers,
});

/**
 * `POST /v1/system_domains/referral_code/{referral_code}/`
 *
 * Create a new system domain from a referral code (That is associated to your domain)
 *
 *
 * Responses
 * - 201 - Returns a created system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainFromTemplateSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains_referral_code__referral_code__}
 */
export const httpPostSystemDomainsReferralCodeByReferralCode = (
  referralCode: string,
  body: AuthSystemDomainFromReferralCodeSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomainsReferralCodeByReferralCode,
  method: httpMethod.post,
  url: `/API/auth/v1/system_domains/referral_code/${encodeURIComponent(referralCode)}/`,
  params: { referralCode },
  body,
  headers,
});

export interface AuthHttpGetSystemDomainsSearchQuery {
  page?: number;
  per_page?: number;
  /**
   * A semicolon separated list of `field,order` pairs. For example - name,asc;status,desc
   */
  sort?: string;
  /**
   * Query name, status, type, referral code or description
   */
  query?: string;
  /**
   * Comma separated list of statuses to show
   */
  statuses?: string;
  /**
   * Comma separated list of types to show
   */
  types?: string;
  /**
   * filter by field_name
   */
  field_name?: string;
}

/**
 * `GET /v1/system_domains/search/`
 *
 * List of system domains from Elasticsearch
 *
 *
 * Responses
 * - 200 - Returns a list of system domains
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_system_domains_search_}
 */
export const httpGetSystemDomainsSearch = (
  query?: AuthHttpGetSystemDomainsSearchQuery,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetSystemDomainsSearch,
  method: httpMethod.get,
  url: '/API/auth/v1/system_domains/search/',

  query,
  headers,
});

/**
 * `GET /v1/system_domains/templates/`
 *
 * List of system domain templates
 *
 *
 * Responses
 * - 200 - Returns a list of system domain templates
 * - 401 - Token is invalid
 *
 * Response {@link AuthSystemDomainsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_system_domains_templates_}
 */
export const httpGetSystemDomainsTemplates = (headers?: IconikApiHeaders) => ({
  id: AuthHttpGetSystemDomainsTemplates,
  method: httpMethod.get,
  url: '/API/auth/v1/system_domains/templates/',

  headers,
});

/**
 * `DELETE /v1/system_domains/{system_domain_id}/`
 *
 * Delete a particular system_domain by id
 *
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_system_domains__system_domain_id__}
 */
export const httpDeleteSystemDomainsBySystemDomainId = (
  systemDomainId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteSystemDomainsBySystemDomainId,
  method: httpMethod.delete,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  headers,
});

/**
 * `GET /v1/system_domains/{system_domain_id}/`
 *
 * Returns a particular system domain by id
 *
 * Required roles:
 *  - can_read_system_domains
 *
 * Responses
 * - 200 - Returns a system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * Response {@link AuthSystemDomainSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/get_v1_system_domains__system_domain_id__}
 */
export const httpGetSystemDomainsBySystemDomainId = (
  systemDomainId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpGetSystemDomainsBySystemDomainId,
  method: httpMethod.get,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  headers,
});

export type AuthSystemDomainSuperAdminSchemaPartial =
  Partial<AuthSystemDomainSuperAdminSchema>;

/**
 * `PATCH /v1/system_domains/{system_domain_id}/`
 *
 * Update system domain
 *
 *
 * Responses
 * - 200 - Returns an updated system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * Response {@link AuthSystemDomainSuperAdminSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_system_domains__system_domain_id__}
 */
export const httpPatchSystemDomainsBySystemDomainId = (
  systemDomainId: string,
  body: AuthSystemDomainSuperAdminSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchSystemDomainsBySystemDomainId,
  method: httpMethod.patch,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `PUT /v1/system_domains/{system_domain_id}/`
 *
 * Update system domain
 *
 *
 * Responses
 * - 200 - Returns an updated system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * Response {@link AuthSystemDomainSuperAdminSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/put_v1_system_domains__system_domain_id__}
 */
export const httpPutSystemDomainsBySystemDomainId = (
  systemDomainId: string,
  body: AuthSystemDomainSuperAdminSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPutSystemDomainsBySystemDomainId,
  method: httpMethod.put,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `DELETE /v1/system_domains/{system_domain_id}/e2e/`
 *
 * Delete a particular system_domain by id.
 *
 * (For internal use. Should not be displayed in Swagger docs)
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_system_domains__system_domain_id__e2e_}
 */
export const httpDeleteSystemDomainsBySystemDomainIdE2E = (
  systemDomainId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteSystemDomainsBySystemDomainIdE2E,
  method: httpMethod.delete,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/e2e/`,
  params: { systemDomainId },
  headers,
});

/**
 * `POST /v1/system_domains/{system_domain_id}/features/`
 *
 * Enable specified feature on a system domain
 *
 *
 * Responses
 * - 200 - Returns a created system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link AuthEnableSystemDomainFeatureSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains__system_domain_id__features_}
 */
export const httpPostSystemDomainsBySystemDomainIdFeatures = (
  systemDomainId: string,
  body: AuthEnableSystemDomainFeatureSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomainsBySystemDomainIdFeatures,
  method: httpMethod.post,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/features/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `DELETE /v1/system_domains/{system_domain_id}/logo/`
 *
 * Delete system domain logo image.
 *
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/delete_v1_system_domains__system_domain_id__logo_}
 */
export const httpDeleteSystemDomainsBySystemDomainIdLogo = (
  systemDomainId: string,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpDeleteSystemDomainsBySystemDomainIdLogo,
  method: httpMethod.delete,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/logo/`,
  params: { systemDomainId },
  headers,
});

/**
 * Returns url for system domain logo
 */
export interface AuthHttpPostSystemDomainsBySystemDomainIdLogoResponse {
  /**
   * Url for the system domain logo
   */
  logo?: string;
}

/**
 * `POST /v1/system_domains/{system_domain_id}/logo/`
 *
 * Upload system domain logo image.
 *
 *
 * Responses
 * - 201 - Returns url for system domain logo
 * - 400 - Bad request
 * - 404 - System domain does not exist
 *
 * Response {@link AuthHttpPostSystemDomainsBySystemDomainIdLogoResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains__system_domain_id__logo_}
 */
export const httpPostSystemDomainsBySystemDomainIdLogo = (
  systemDomainId: string,
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomainsBySystemDomainIdLogo,
  method: httpMethod.post,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/logo/`,
  params: { systemDomainId },
  body: formData,
  headers,
});

export type AuthSystemDomainProfileSchemaPartial =
  Partial<AuthSystemDomainProfileSchema>;

/**
 * `PATCH /v1/system_domains/{system_domain_id}/profile/`
 *
 * Update system domain profile
 *
 *
 * Responses
 * - 200 - Returns an updated system domain
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - System domain does not exist
 *
 * Response {@link AuthSystemDomainProfileSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/patch_v1_system_domains__system_domain_id__profile_}
 */
export const httpPatchSystemDomainsBySystemDomainIdProfile = (
  systemDomainId: string,
  body: AuthSystemDomainProfileSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPatchSystemDomainsBySystemDomainIdProfile,
  method: httpMethod.patch,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/profile/`,
  params: { systemDomainId },
  body,
  headers,
});

/**
 * `POST /v1/system_domains/{system_domain_id}/reindex/`
 *
 * Reindex system_domain
 *
 * Required roles:
 *  - can_read_system_domains
 *
 * Responses
 * - 202 - OK
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/auth/spec/#/default/post_v1_system_domains__system_domain_id__reindex_}
 */
export const httpPostSystemDomainsBySystemDomainIdReindex = (
  systemDomainId: string,
  body: AuthReindexSystemDomainSchema,
  headers?: IconikApiHeaders,
) => ({
  id: AuthHttpPostSystemDomainsBySystemDomainIdReindex,
  method: httpMethod.post,
  url: `/API/auth/v1/system_domains/${encodeURIComponent(systemDomainId)}/reindex/`,
  params: { systemDomainId },
  body,
  headers,
});
